/* =========================================================================
 * IBC 2.0 — BUNDLE BUILDER
 * -------------------------------------------------------------------------
 * Drives sections/ibc-bundle.liquid. ONE cart line is ever created: the IBC
 * Bundle product, quantity 1, carrying the customer's choice as line-item
 * properties. A Cart Transform Function expands that line into component
 * lines at checkout — nothing here creates child lines, and nothing here
 * writes to Shopify beyond /cart/add.js and /cart/change.js.
 *
 * PROPERTY CONTRACT — shared with the cart worker and with the Function.
 * Exactly these, and nothing else. NOT ONE OF THESE NAMES HAS CHANGED with
 * the size-selector and budget work, and none may:
 *
 *   Bundle ID            'ibc-1756056000000-a3f9'
 *                        public. Unique per add, so Shopify cannot merge two
 *                        differently-configured bundles into one line.
 *   <the step's title>   one public property PER STEP, keyed by that step's
 *                        own configured wording, e.g.
 *                          'Choose five treats':
 *                          '3 × Honeycomb Bite, 2 × Orange Dragée — Dark'
 *                        `${quantity} × ${title}` with U+00D7 MULTIPLICATION
 *                        SIGN, quantity first, comma-separated, and the
 *                        variant appended as ' — <variant>' when it is not
 *                        'Default Title'. This is the theme's established
 *                        convention — see the gift box's
 *                        'Gift Box Selection'.
 *   _IBC Bundle Items    private (the leading underscore hides it from the
 *                        customer). The machine record:
 *                        [{"id":<variantId>,"q":<qty>,"t":"<tierKey>",
 *                          "p":"<product title>","v":"<variant title>"}]
 *
 * THE STEP'S TITLE IS THE PROPERTY NAME AND IS NO LONGER SHOWN. The visible
 * wording moved to `step.label` when the labels became Cake / Favourites /
 * Treats. `properties()` keys on `step.title` exactly as it always has, so
 * the three public properties on an order are unchanged; every string a
 * customer reads comes from `stepLabel()`. If you find yourself about to
 * write `step.title` into anything a customer sees, you are undoing that.
 *
 * NO internal tier key and no parent/child marker is ever a customer-visible
 * property. The words big/medium/small/tier never appear in this file's
 * output.
 *
 * THE BUDGET, AND WHAT REPLACED THE COUNTING
 * ------------------------------------------
 * The chosen bundle VARIANT's price is the budget. Every selected item
 * spends its own real variant price against it. There is no per-tier
 * allowance: `step.required` survives as a per-step CAP (0 = as many as the
 * budget allows) and gates nothing else. Under-filling warns; it only blocks
 * when the merchant has set a minimum-spend percentage.
 *
 * An item that will not fit opens `openDialog()` — an inline dialog, never
 * window.confirm and never window.alert. Not on the largest size it offers
 * the next larger one, carrying every existing selection across untouched.
 * On the largest size it offers the item at its own full price, shown, as an
 * EXTRA.
 *
 * EXTRAS ARE NOT IN THE BUNDLE. An extra is held in `this.extras`, never in
 * `this.picks`; it is not counted against the budget, it never reaches
 * `_IBC Bundle Items` or any step property, and at the add it becomes its
 * OWN ORDINARY CART LINE — `{ id, quantity }` with no properties at all — in
 * the same /cart/add.js call as the bundle line. That is the whole of its
 * representation: an extra in the basket is indistinguishable from the same
 * chocolate bought on its own page, which is exactly what it is.
 *
 * THE SIZE. `bundle.variants[]` from the island, sorted by price ascending.
 * "The next larger size" is the next entry in that order and nothing else —
 * no variant title is parsed and no id is hard-coded anywhere in this file.
 * Choosing one goes through window.IbcProduct.select(productId, variantId)
 * so the page's own picker, price and gallery move with it; the tiles are
 * real `?variant=` links and the interception only happens when that
 * function exists, so a script that fails to load leaves a working control.
 * The idiom is assets/ibc-gift-box.js `chooseSize`.
 *
 * THE TIER IS A PROPERTY OF THE VARIANT. `custom.ibc_bundle_tier` is read at
 * variant level, falling back to the product's value for a blank variant —
 * snippets/ibc-bundle-json.liquid states the resolution chain in full and is
 * the only writer of the island this file reads. Each entry of `products[]`
 * therefore looks like
 *
 *   { id, handle, title, image, url,
 *     variants: [ { id, title, available, image, tier } ] }
 *
 * with NO product-level `tier` key, and with only the variants that resolved
 * to a tier present at all. ONE PRODUCT CAN BELONG TO TWO STEPS: Spezzatura
 * Bags are a favourite at 100g and a treat at 50g, and each step's card
 * offers only that step's variants. Everything downstream — the picks, the
 * consolidation, the summary, the cart record — already keyed on VARIANT id
 * and is unaffected by that.
 *
 * THE 50-PRODUCT CEILING. Liquid can only render 50 products per request, so
 * the section renders page 1 and this file fetches the rest of the eligible
 * collection through the Section Rendering API — the same section, the same
 * data island, `?section_id=<id>&page=N` — and merges what it did not have.
 * The metafield that decides eligibility is only readable from Liquid, which
 * is why this is a section fetch and not /collections/x/products.json.
 * `place()` does the placing for both, and skips any product a grid already
 * holds a card for, so the merge cannot double a card and a product in two
 * steps cannot be merged away into one.
 *
 * EDIT MODE. `?edit=<line key>` fetches /cart.js, finds the line by key and
 * rebuilds the whole selection from that line's `_IBC Bundle Items`. Saving
 * calls /cart/change.js ONCE against the same key, so the line is updated in
 * place and never duplicated. The cart is the only source of truth: nothing
 * here reads or needs sessionStorage. An item whose product has since left
 * the eligible collection is still restored — from the titles stored in the
 * property itself — and shown as no longer available, so the customer's work
 * is never silently thrown away.
 *
 * THE FLOW. A size stage, then the steps, then a review stage. `advance()`
 * is the ONLY way forward
 * and it serves all three views of the Continue control — the one in the
 * step's nav row, the one in the step's heading on desktop, and the one on
 * the mobile bar. All three carry `data-ibcb-next` and the same two label
 * attributes; `paintAdvance()` paints all three and one click branch handles
 * all three. On the last step, and on any step reached from a review Edit,
 * the control reads the review wording and opens the review instead.
 *
 * A CONTINUE THAT CANNOT ADVANCE IS NOT A DEAD BUTTON. It carries
 * `aria-disabled` rather than `disabled`, so it stays focusable and pressing
 * it still does something: it speaks the reason through the live region and
 * moves the cursor to the control that would fix the step. A `disabled`
 * button on fixed furniture is unreachable by keyboard and silent to a
 * screen reader at the moment the customer most needs telling.
 *
 * RE-ENTRY: the module is behind `if (window.IbcBundle) return;`. Every
 * listener that is not on a builder's own root is bound once at module
 * scope and dispatches to whichever instances are live;
 * `shopify:section:unload` disposes them. The idiom is
 * assets/ibc-gift-box.js.
 * ====================================================================== */
(function () {
  'use strict';

  /* Loaded twice — a second script tag, a theme-editor re-render, an app
   * embed — must not re-bind anything. The first copy owns the feature. */
  if (window.IbcBundle) return;

  var TIMES = '×'; /* U+00D7 MULTIPLICATION SIGN, never the letter x */
  var DASH = '—'; /* U+2014 EM DASH, the variant separator */
  var DEFAULT_TITLE = 'Default Title';

  var PROPS = {
    id: 'Bundle ID',
    items: '_IBC Bundle Items',
    /* THE JOIN. Every line of one bundle — the header and every chocolate in
     * it — carries the same `_Bundle Group`, and it is the header's own
     * `Bundle ID`. Private, so the customer is not shown a machine key, and
     * unique per add, so two bundles in one basket cannot merge and a
     * chocolate bought on its own page can never be swallowed into one.
     *
     * The idiom is the multipack's `_Selection ID` (assets/ibc-multipack.js),
     * which has done exactly this in production for months. */
    group: '_Bundle Group',
    /* How many of this piece are in ONE bundle, so the group's quantity can
     * be raised in the basket without the arithmetic being guessed at from a
     * line quantity that has already been multiplied. The multipack's
     * `_Selection Unit`, same job. */
    unit: '_Bundle Unit'
  };

  var EDIT_PARAM = 'edit';
  var SHEET_AT = 1079; /* the sheet exists at and below this width */

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
    ' textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ------------------------------------------------------------ helpers -- */

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isSheet() {
    return !!(window.matchMedia && window.matchMedia('(max-width: ' + SHEET_AT + 'px)').matches);
  }

  function param(name) {
    var search = window.location.search || '';
    var match = new RegExp('[?&]' + name + '=([^&#]*)').exec(search);
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
  }

  /* 'ibc-<epoch ms>-<4 lowercase alphanumerics>'. The random tail is what
   * stops two bundles configured in the same millisecond from colliding;
   * the whole point of the value is that Shopify must never merge two
   * differently-configured bundle lines. */
  function fetchCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(
      function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      }
    );
  }

  function bundleId() {
    var alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var tail = '';
    var i;
    for (i = 0; i < 4; i += 1) {
      tail += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    }
    return 'ibc-' + Date.now() + '-' + tail;
  }

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!response.ok) {
            var message = (data && (data.description || data.message)) || 'HTTP ' + response.status;
            var error = new Error(message);
            error.data = data;
            throw error;
          }
          return data;
        });
    });
  }

  /* ==================================================================== */

  function Builder(node) {
    this.el = node;
    this.uid = node.getAttribute('data-ibcb-section-id') || '';
    this.maxPages = parseInt(node.getAttribute('data-ibcb-max-pages'), 10) || 1;
    this.emptySlot = node.getAttribute('data-ibcb-empty-slot') || 'Still to choose';

    var island = node.querySelector('script[type="application/json"][data-ibcb-data]');
    var data = {};
    try {
      data = island ? JSON.parse(island.textContent) : {};
    } catch (error) {
      data = {};
    }

    this.bundle = data.bundle || {};
    this.steps = data.steps || [];

    /* ------------------------------------------------------- the budget --
     * THE SIZES, PRICE ASCENDING. Sorted here, once, because every question
     * this file asks about sizes — which is current, which is next larger,
     * which is the largest — is a question about that order and nothing
     * else. No variant title is parsed and no id is written down: the day
     * the merchant renames "Large" to "Sharing" nothing here notices.
     *
     * `slice()` first: `sort` is in place and the island's array is the
     * document order the size tiles were rendered in. */
    this.sizes = (this.bundle.variants || []).slice().sort(function (a, b) {
      /* BY ROOM, THEN BY PRICE.
       *
       * Price alone was right while the sizes carried the budget. They are
       * GBP 0 now — the bundle costs what is in it — so a price sort puts
       * Standard and Large in whatever order the array arrived in, and
       * `nextLarger` (which wants a strictly greater price) would find no
       * larger size at all and never offer the upgrade. Capacity is what
       * "larger" has actually meant since the money came out. Price stays as
       * the tie-break for a shop that does charge per size. */
      var ca = parseInt(a.capacity, 10) || 0;
      var cb = parseInt(b.capacity, 10) || 0;
      if (ca !== cb) return ca - cb;
      return (a.price || 0) - (b.price || 0);
    });
    this.sizeId = String(this.bundle.variantId || '');
    this.money = this.bundle.money || {};
    this.hasSizes = node.getAttribute('data-ibcb-has-sizes') === 'true';

    /* ------------------------------------------------------- the hamper --
     * A SECOND PRODUCT, not an option on this one, because the shop orders
     * the hampers in and wants them on the order as their own line.
     *
     * WHAT IS REMEMBERED IS "DO THEY WANT ONE", NOT "WHICH ONE". The variant
     * is resolved from the size every time it is asked for, which is the
     * whole of the "moving up to the Large takes the hamper from GBP 10 to
     * GBP 15" behaviour: there is no second choice to keep in step with the
     * size, because there is no second choice. */
    this.hamper = data.hamper || null;
    this.hamperVariants = (this.hamper && this.hamper.variants) || [];
    this.hasHamper =
      node.getAttribute('data-ibcb-has-hamper') === 'true' && this.hamperVariants.length > 0;
    /* ON BY DEFAULT. The basket is what completes a hamper, so the hamper is
     * what the customer is offered and the plain box is the way out of it.
     *
     * NEVER on an edit. Somebody who came back from the basket to change a
     * chocolate has already decided about the basket, and defaulting it on
     * would silently add one they had declined. `loadEdit` clears this and
     * reads the truth from the cart. */
    this.hamperOn = this.hasHamper && !this.editKey;
    this.hamperLabel = node.getAttribute('data-ibcb-hamper-label') || '';
    this.presStage = node.querySelector('[data-ibcb-pres]');
    this.presOpen = false;
    /* Ticked once the customer has been through the stage, not once a value
     * exists — "no hamper" is a real answer and it is also the default, so
     * a tick on the value alone would tick before they had decided. */
    this.seenPres = false;

    /* A percentage of the chosen size's price, 0 for "warn only". Read off
     * the root rather than the island: it is a presentation setting of this
     * section, not a fact about the catalogue. */
    this.minSpendPct = parseInt(node.getAttribute('data-ibcb-min-spend-pct'), 10) || 0;
    /* WHAT AN UNMEASURED ITEM COSTS IN ROOM. Every eligible variant is meant
     * to carry `custom.ibc_bundle_units`, but a chocolate added to the
     * collection this morning will not, and a builder that treated a missing
     * number as zero would let a customer fill a hamper with things that take
     * no space at all. One unit is the smallest honest answer. */
    this.defaultUnits = parseInt(node.getAttribute('data-ibcb-default-units'), 10) || 1;
    this.classMax = parseInt(node.getAttribute('data-ibcb-class-max'), 10) || 1;
    /* OFF MEANS THE LARGEST SIZE IS A HARD CAP. The over-size path still
     * exists in full — see `addExtra` and `promptOverBudget` — and is simply
     * not offered, so turning it back on is a checkbox rather than a
     * rebuild. */
    this.allowExtras = node.getAttribute('data-ibcb-allow-extras') === 'true';
    this.extrasHeading = node.getAttribute('data-ibcb-extras-heading') || 'Added separately';

    /* EXTRAS: [{ id, qty }], flat and NOT per step, because an extra does
     * not belong to a step — it is not in the bundle at all. Kept apart from
     * `picks` so that nothing which walks `picks` (the payload, the budget,
     * the summary counts) can ever pick one up by accident. */
    this.extras = [];

    /* variantId -> { pid, handle, product, variant, tier }, the index every
     * lookup in this file goes through. `tier` is the VARIANT's tier — one
     * product can hold variants of two tiers and therefore belong to two
     * steps. Products merged from later pages of the collection are added to
     * it as they arrive. */
    this.byVariant = {};
    this.firstVariant = {};
    this.seen = {};
    this.index(data.products || []);

    /* picks[stepIndex] = [ { id: '<variantId>', qty: n } ] in the order the
     * customer chose them. THE CONSOLIDATION RULE LIVES HERE: one entry per
     * VARIANT per step, so the same variant twice is one entry with qty 2,
     * and two different variants of one product are two entries. */
    this.picks = [];
    var i;
    for (i = 0; i < this.steps.length; i += 1) this.picks.push([]);

    /* Restored from the cart in edit mode when the catalogue no longer holds
     * the variant: variantId -> { p: productTitle, v: variantTitle }. */
    this.stubs = {};

    this.step = 0;
    this.busy = false;
    this.editKey = param(EDIT_PARAM);
    this.savedId = '';
    this.trayOpener = null;

    /* The review stage. `reviewFrom` is the step the customer left, so Back
     * and Escape put them back where they were. `reviewReturn` is set only by
     * an Edit control in the review: while it is true the advance control
     * reads the review wording and goes back to the review, on whatever step
     * the customer is standing — the label and the action never disagree. */
    this.reviewOpen = false;
    this.reviewFrom = 0;
    this.reviewReturn = false;

    /* The size stage. The THIRD shape of the one stage machine, and handled
     * exactly like the review: a sibling of the panels which the script
     * shows in their place. It exists only when Liquid rendered it, which it
     * does only when the bundle product has more than one variant — see the
     * section. `sizeOpen` therefore stays false for ever on a one-variant
     * product and every branch below collapses to today's behaviour. */
    this.sizeStage = node.querySelector('[data-ibcb-size]');
    this.sizeOpen = false;

    /* The inline dialog. One shell in the document from first paint; the
     * actions are rebuilt per situation and dispatched by index through the
     * one delegated listener, so no per-node listener can leak. */
    this.dialog = node.querySelector('[data-ibcb-dialog]');
    this.dialogPanel = node.querySelector('[data-ibcb-dialog-panel]');
    this.dialogTitle = node.querySelector('[data-ibcb-dialog-title]');
    this.dialogBody = node.querySelector('[data-ibcb-dialog-body]');
    this.dialogActions = node.querySelector('[data-ibcb-dialog-actions]');
    this.dialogTrigger = null;
    this._actions = [];

    this.layout = node.querySelector('[data-ibcb-layout], .ibcb__layout');
    /* `tabsStrip` has gone with `revealTab()`: it was the scroll container and
     * nothing else read it. `data-ibcb-tabs` stays on the <ol> in the markup —
     * it is a documented hook in CONTRACT.md §2 and costs nothing. */
    this.tabs = toArray(node.querySelectorAll('[data-ibcb-tab]'));
    this.panels = toArray(node.querySelectorAll('[data-ibcb-panel]'));
    this.sumSteps = toArray(node.querySelectorAll('[data-ibcb-sum-step]'));
    this.live = node.querySelector('[data-ibcb-live]');
    this.overall = node.querySelector('[data-ibcb-overall]');
    this.barCount = node.querySelector('[data-ibcb-bar-count]');
    /* The two advance controls that stand OUTSIDE the step panels — the
     * mobile bar's and the summary's — cannot point at a panel note for
     * their reason, so each carries its own hidden one. Both are painted
     * from the same `blockReason()` sentence in `paintAdvance()`. */
    this.floatNotes = toArray(
      node.querySelectorAll('[data-ibcb-bar-note], [data-ibcb-aside-note]')
    );
    this.aside = node.querySelector('[data-ibcb-aside]');
    this.scrim = node.querySelector('[data-ibcb-scrim]');

    this.review = node.querySelector('[data-ibcb-review]');
    /* `[data-ibcb-extras]` also carries `.ibcb__review-step`, and it is NOT
     * one of the steps — it holds the items that are deliberately outside
     * the bundle. Excluded here rather than in every painter. */
    this.reviewSteps = toArray(node.querySelectorAll('[data-ibcb-review-step]')).filter(
      function (section) {
        return !section.hasAttribute('data-ibcb-extras');
      }
    );
    this.reviewOverall = node.querySelector('[data-ibcb-review-overall]');
    this.extrasBox = node.querySelector('[data-ibcb-extras]');
    this.extrasList = node.querySelector('[data-ibcb-extras-list]');
    this.extrasCount = node.querySelector('[data-ibcb-extras-count]');
    this.sumExtras = node.querySelector('[data-ibcb-sum-extras]');
    this.sumExtrasList = node.querySelector('[data-ibcb-sum-extras-list]');
    this.sumExtrasCount = node.querySelector('[data-ibcb-sum-extras-count]');
    this.spendNote = node.querySelector('[data-ibcb-spend]');
    /* TWO COPIES NOW, NOT ONE. The single boxed back control on the steps bar
     * has gone; the small underlined one that replaces it sits beside Continue
     * in both places Continue is furniture outside the panels — the persistent
     * bar on a phone, the summary's title row on desktop. Same hook, same
     * `goBack()`, and every one of them painted from the one `backTarget()`
     * answer, so a list here rather than a `querySelector` that would silently
     * paint the first and leave the other stale. */
    this.stepBacks = toArray(node.querySelectorAll('[data-ibcb-step-back]'));

    /* The buy block is rendered twice — in the preview aside and in the
     * review stage — and both copies say the same thing at the same time, so
     * every one of these is a list and every painter walks it. */
    this.submits = toArray(node.querySelectorAll('[data-ibcb-submit]'));
    this.submitNotes = toArray(node.querySelectorAll('[data-ibcb-submit-note]'));
    this.errorBoxes = toArray(node.querySelectorAll('[data-ibcb-error]'));

    node._ibcBundle = this;
    node.classList.add('is-ready');

    /* Before the first paint: give every step the products Liquid could not
     * hand it — the ones whose tier lives only on their variants. The script
     * is deferred, so this runs after the grids are parsed and before the
     * customer sees them. */
    this.place(data.products || []);

    /* THE SIZE STAGE IS THE FIRST STAGE when there is one. Opened silently,
     * so nothing is announced and nothing is scrolled to on first paint —
     * the customer has only just arrived on the page.
     *
     * Editing a bundle already in the basket is the one exception: that
     * customer chose a size when they built it, `?variant=` is on the URL
     * they came back through, and putting them back on stage zero would
     * invite them to change it by accident. They land on the first step. */
    this.step = 0;
    /* Both conditions, deliberately: Liquid decided whether a size stage was
     * worth rendering (`data-ibcb-has-sizes`) and the stage's presence in the
     * DOM is the other half of the same answer. Requiring both means a
     * cached fragment that disagrees with the attribute opens on a step
     * rather than on a stage that may be empty. */
    this.sizeOpen = !!this.sizeStage && this.hasSizes && !this.editKey;
    /* The presentation stage opens first when there is no size to choose,
     * and after the size when there is. Never on an edit: somebody who came
     * from the basket to change a chocolate should land on the chocolates,
     * not be walked through the stages again. */
    this.presOpen = !this.sizeOpen && !!this.presStage && !this.editKey;

    this.render();
    if (!this.sizeOpen) this.setStep(0, { silent: true });
    this.loadPages();
    if (this.editKey) this.loadEdit();
  }

  /* ------------------------------------------------------- the catalogue -- */

  Builder.prototype.index = function (products) {
    var self = this;
    var added = [];
    (products || []).forEach(function (product) {
      if (!product || self.seen[product.id]) return;
      self.seen[product.id] = true;
      added.push(product);
      (product.variants || []).forEach(function (variant) {
        if (self.firstVariant[product.id] === undefined) {
          self.firstVariant[product.id] = String(variant.id);
        }
        self.byVariant[String(variant.id)] = {
          pid: product.id,
          handle: product.handle,
          tier: variant.tier || '',
          title: product.title,
          url: product.url,
          /* THE VARIANT'S OWN PICTURE, and its candidate list and its
           * dimensions with it. The island already applies the
           * product-featured fallback per variant, so `variant.image` is
           * populated for every variant it emits; the `||` chain stays as a
           * belt-and-braces for an island written by an older render of
           * snippets/ibc-bundle-json.liquid, which is a real possibility
           * while a page is being previewed mid-deploy. `srcset` is carried
           * BESIDE `src` and never derived from it — see `swapCardImage`. */
          image: variant.image || product.image || '',
          srcset: variant.imageSrcset || product.imageSrcset || '',
          imageWidth: variant.imageWidth || product.imageWidth || 0,
          imageHeight: variant.imageHeight || product.imageHeight || 0,
          variant: variant
        };
      });
    });
    return added;
  };

  /* The variants of one product that belong in one step. The island carries
   * only variants that resolved to a tier at all, so `tier === stepKey` is
   * the whole of the per-step filter — and it is exactly the filter
   * snippets/ibc-bundle-card.liquid applies to the same product server-side. */
  Builder.prototype.variantsFor = function (product, tierKey) {
    return (product.variants || []).filter(function (variant) {
      return !!variant && variant.tier === tierKey;
    });
  };

  /* Everything this file needs to describe one chosen variant, whether it
   * came from the catalogue or — in edit mode — only from the cart. */
  Builder.prototype.info = function (variantId) {
    var key = String(variantId);
    var found = this.byVariant[key];
    if (found) {
      return {
        p: found.title,
        v: found.variant.title || '',
        image: found.image,
        srcset: found.srcset,
        imageWidth: found.imageWidth,
        imageHeight: found.imageHeight,
        handle: found.handle,
        available: found.variant.available !== false,
        /* The variant's own real price, in minor units — what this item
         * spends against the budget, and what it costs on its own line if
         * it is taken as an extra. */
        price: parseInt(found.variant.price, 10) || 0,
        /* HOW MUCH ROOM THIS TAKES. 0 means the shop has not sized this one
         * yet; `unitsOf` substitutes the section's default rather than
         * letting an unmeasured chocolate ride along taking no space. */
        units: parseInt(found.variant.units, 10) || 0,
        /* The kind this belongs to, for rules about a group of items rather
         * than about one — `whole-cake` and nothing else, today. */
        kind: String(found.variant.kind || ''),
        gone: false
      };
    }
    var stub = this.stubs[key] || {};
    return {
      p: stub.p || 'This item',
      v: stub.v || '',
      image: '',
      srcset: '',
      imageWidth: 0,
      imageHeight: 0,
      handle: '',
      available: false,
      /* An item restored from the cart whose product has left the catalogue
       * has no price we can vouch for. 0, so a stub can never inflate the
       * spend and push a bundle over its own budget behind the customer's
       * back. It is already shown as no longer available. */
      price: 0,
      /* A stub is sized at the default too. It is already shown as no longer
       * available, and a restored bundle that silently shrank to fit would
       * be worse than one that reads as slightly over. */
      units: 0,
      /* A stub's kind is unknown, so it counts towards no limit. It is
       * already shown as no longer available and the customer is being asked
       * to replace it; refusing them a cake because a cake they can no longer
       * have is still listed would be the wrong way round. */
      kind: '',
      gone: true
    };
  };

  /* The customer-facing name of a step. NEVER `step.title` — that is the
   * line-item property name and is not shown. Falls back to it only when a
   * builder configured before the split has no label at all. */
  Builder.prototype.stepLabel = function (index) {
    var step = this.steps[index] || {};
    return step.label || step.title || '';
  };

  /* ------------------------------------------------------------- money --
   * THE ONE PLACE THIS FILE FORMATS MONEY. Everything the builder used to
   * show was a fixed amount Liquid pre-rendered, and the rule was that the
   * JS never formatted money at all. The budget broke that: how much of the
   * bundle is unspent depends on what the customer picked, so no filter can
   * have run over it. The shop's OWN format string comes across in the
   * island (`bundle.money.format`) and is filled in here — the standard
   * Shopify placeholders and nothing invented. If it is missing or the sum
   * is not a number, `bundle.money.zero` — Liquid's own rendering of nought
   * — is shown rather than a bare number with no currency on it. */

  function groupThousands(digits) {
    return String(digits).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  Builder.prototype.formatMoney = function (cents) {
    var amount = Math.round(parseFloat(cents) || 0);
    var format = this.money.format || '';
    if (!format) return this.money.zero || String(amount);

    var negative = amount < 0;
    var abs = Math.abs(amount);
    var whole = Math.floor(abs / 100);
    var part = String(abs % 100);
    while (part.length < 2) part = '0' + part;

    var withDecimals = groupThousands(whole) + '.' + part;
    var noDecimals = groupThousands(Math.round(abs / 100));
    var commaSeparator = groupThousands(whole).replace(/,/g, '.') + ',' + part;
    var commaNoDecimals = groupThousands(Math.round(abs / 100)).replace(/,/g, '.');

    var out = format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaSeparator)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, commaNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals);

    return negative ? '-' + out : out;
  };

  /* ------------------------------------------------ budget arithmetic --
   * THIS REPLACED THE SLOT ARITHMETIC. There is no quota to satisfy and no
   * step to complete: an item costs its own price, the chosen size's price
   * is the ceiling, and everything below is a fact about money or about a
   * per-step cap the merchant may or may not have set. */

  /* The size the customer is on, as an entry of `this.sizes`. Found by id,
   * falling back to the island's own `bundle.price` when the sizes array is
   * empty — a shop whose bundle product somehow has no variants still gets
   * a budget rather than a zero that blocks everything. */
  Builder.prototype.currentSize = function () {
    var key = String(this.sizeId);
    var found = null;
    this.sizes.forEach(function (size) {
      if (String(size.id) === key) found = size;
    });
    return found;
  };

  Builder.prototype.budget = function () {
    var size = this.currentSize();
    if (size) return parseInt(size.price, 10) || 0;
    return parseInt(this.bundle.price, 10) || 0;
  };

  /* What the picks cost. EXTRAS ARE NOT IN HERE, deliberately: an extra is
   * bought on its own line at its own price and does not spend the budget.
   * That is the whole of what "extra" means. */
  Builder.prototype.spent = function () {
    var self = this;
    var total = 0;
    this.picks.forEach(function (list) {
      (list || []).forEach(function (pick) {
        total += self.info(pick.id).price * pick.qty;
      });
    });
    return total;
  };

  /* HOW MUCH THIS SIZE HOLDS, in capacity units, off the chosen variant's
   * `custom.ibc_bundle_capacity`.
   *
   * ZERO MEANS NO LIMIT, NOT NO ROOM. The metafield does not exist until the
   * shop loads the numbers, and a builder that read an absent definition as a
   * full box would refuse the first chocolate anybody tried to add. So an
   * unsized bundle behaves exactly as this builder did before capacity
   * existed: everything fits, and the bar reads empty. */
  Builder.prototype.capacity = function () {
    var size = this.currentSize();
    return size ? parseInt(size.capacity, 10) || 0 : 0;
  };

  /* Is there a limit at all? Asked wherever the answer changes what the
   * customer is TOLD, rather than what they are allowed to do — "your bundle
   * is 60% full" is a sentence with no meaning when nothing has been sized,
   * and silence is better than a made-up percentage. */
  Builder.prototype.capped = function () {
    return this.capacity() > 0;
  };

  /* The room one variant takes. The section's default stands in for anything
   * the shop has not sized, so an unmeasured item costs something rather than
   * nothing. */
  Builder.prototype.unitsOf = function (variantId) {
    var units = this.info(variantId).units;
    return units > 0 ? units : this.defaultUnits;
  };

  /* Room used by the picks. EXTRAS ARE NOT IN HERE, for the same reason they
   * were never in `spent()`: an extra travels on its own line and does not go
   * in the box. */
  Builder.prototype.used = function () {
    var self = this;
    var total = 0;
    this.picks.forEach(function (list) {
      (list || []).forEach(function (pick) {
        total += self.unitsOf(pick.id) * pick.qty;
      });
    });
    return total;
  };

  /* Room left, in units — or NULL when nothing has been sized, which is not
   * the same as none left and must not read as a full box. Every caller
   * checks for null rather than comparing it, because `null > 0` is false and
   * would quietly turn "no limit" into "full". */
  Builder.prototype.remaining = function () {
    if (!this.capped()) return null;
    return this.capacity() - this.used();
  };

  /* 0..100, and never above it. Measured in ROOM now, not in money: the
   * bundle costs what is in it, so the price stopped being a ceiling the day
   * the sizes went to zero and the box's own volume took over.
   *
   * A capacity of 0 reads as EMPTY rather than as full, and deliberately: an
   * empty bar invites the customer to fill it, a full one tells them to stop,
   * and stopping is the wrong advice to give somebody whose shop simply has
   * not loaded its numbers yet. */
  Builder.prototype.fullness = function () {
    var capacity = this.capacity();
    if (capacity <= 0) return 0;
    var pct = Math.round((this.used() / capacity) * 100);
    if (pct < 0) return 0;
    return pct > 100 ? 100 : pct;
  };

  /* The minimum spend, in minor units. 0 when the merchant has not set one,
   * which is the default and means "warn only". */
  Builder.prototype.minSpend = function () {
    if (this.minSpendPct <= 0) return 0;
    return Math.round((this.budget() * this.minSpendPct) / 100);
  };

  Builder.prototype.belowMinimum = function () {
    var floor = this.minSpend();
    return floor > 0 && this.spent() < floor;
  };

  /* Would adding this many of this variant fit the box? The per-step cap and
   * the room are two separate answers because the customer is told two
   * different things — one is "that is as many cakes as this holds", the
   * other is "the box is full".
   *
   * Nothing sized, nothing refused. */
  Builder.prototype.fits = function (variantId, quantity) {
    if (!this.capped()) return true;
    return this.used() + this.unitsOf(variantId) * (quantity || 1) <= this.capacity();
  };

  /* The per-step CAP — `required`, kept for its id and its stored values and
   * re-read as a maximum. 0 means "as many as the budget allows", which is
   * the usual answer. The cake step's 1 is what makes it at most one cake. */
  Builder.prototype.maxOf = function (index) {
    var step = this.steps[index];
    var cap = step ? parseInt(step.required, 10) : 0;
    return cap > 0 ? cap : 0;
  };

  Builder.prototype.atCap = function (index) {
    var cap = this.maxOf(index);
    return cap > 0 && this.count(index) >= cap;
  };

  Builder.prototype.count = function (index) {
    var total = 0;
    (this.picks[index] || []).forEach(function (pick) {
      total += pick.qty;
    });
    return total;
  };

  Builder.prototype.qtyOf = function (index, variantId) {
    var key = String(variantId);
    var found = 0;
    (this.picks[index] || []).forEach(function (pick) {
      if (pick.id === key) found = pick.qty;
    });
    return found;
  };

  /* "This step is finished" no longer exists as a concept, and neither does
   * "this step is full" unless the merchant set a cap. `canAdd` is now the
   * cap question ONLY — whether the item fits the budget is `fits()`, asked
   * separately in `add()`, because the two failures need different answers
   * and only one of them opens a dialog. */
  Builder.prototype.kindOf = function (variantId) {
    return String(this.info(variantId).kind || '');
  };

  /* How many of one kind are in the bundle, across every step. Across every
   * step deliberately: a kind is a fact about the thing, not about where the
   * shop filed it, and a cake that appeared under Favourites would otherwise
   * slip the limit. */
  Builder.prototype.countOfKind = function (kind) {
    var self = this;
    if (!kind) return 0;
    var total = 0;
    this.picks.forEach(function (list) {
      (list || []).forEach(function (pick) {
        if (self.kindOf(pick.id) === kind) total += pick.qty;
      });
    });
    return total;
  };

  Builder.prototype.atKindLimit = function (kind) {
    if (!kind) return false;
    return this.countOfKind(kind) >= this.classMax;
  };

  /* THE SMALLEST SIZE THIS WOULD FIT IN, empty. A fact about the item and
   * the sizes and nothing else — not about how full the bundle is — so a
   * card can state it without it changing under the customer as they choose.
   * Null when nothing is sized, or when nothing on offer is big enough. */
  /* Would this fit the current size in an EMPTY bundle? The question the
   * card asks, as against `fits()`, which asks about the bundle as it stands.
   * The two differ exactly when the box is merely full, and that is the case
   * the card must stay quiet about. */
  Builder.prototype.fitsEmpty = function (variantId) {
    if (!this.capped()) return true;
    return this.unitsOf(variantId) <= this.capacity();
  };

  Builder.prototype.sizeNeededFor = function (variantId) {
    var units = this.unitsOf(variantId);
    var found = null;
    this.sizes.forEach(function (size) {
      if (found) return;
      var capacity = parseInt(size.capacity, 10) || 0;
      if (capacity > 0 && capacity >= units) found = size;
    });
    return found;
  };

  Builder.prototype.canAdd = function (index) {
    return !this.atCap(index);
  };

  Builder.prototype.totalChosen = function () {
    var total = 0;
    var i;
    for (i = 0; i < this.steps.length; i += 1) total += this.count(i);
    return total;
  };

  Builder.prototype.extraCount = function () {
    var total = 0;
    this.extras.forEach(function (extra) {
      total += extra.qty;
    });
    return total;
  };

  Builder.prototype.extrasTotal = function () {
    var self = this;
    var total = 0;
    this.extras.forEach(function (extra) {
      total += self.info(extra.id).price * extra.qty;
    });
    return total;
  };

  Builder.prototype.qtyOfExtra = function (variantId) {
    var key = String(variantId);
    var found = 0;
    this.extras.forEach(function (extra) {
      if (extra.id === key) found = extra.qty;
    });
    return found;
  };

  /* THE ADD BUTTON'S GATE. Everything that used to be counted is gone: what
   * is left is that the bundle can be bought at all, that nothing chosen has
   * sold out, and — only when the merchant asked for one — that the spend
   * has reached the floor. An under-filled bundle is a warning, not a wall. */
  Builder.prototype.satisfied = function () {
    var i;
    if (!this.steps.length) return false;
    if (!this.bundle.variantId) return false;
    for (i = 0; i < this.steps.length; i += 1) {
      if (this.hasGone(i)) return false;
    }
    if (this.belowMinimum()) return false;
    return true;
  };

  Builder.prototype.hasGone = function (index) {
    var self = this;
    var gone = false;
    (this.picks[index] || []).forEach(function (pick) {
      if (self.info(pick.id).gone || !self.info(pick.id).available) gone = true;
    });
    return gone;
  };

  /* EVERY STEP IS REACHABLE, ALWAYS. This used to require every earlier step
   * to be exactly satisfied, which is what disabled the tabs. With no quota
   * to satisfy there is nothing to gate on, and the brief is explicit: all
   * three steps visible and navigable at all times. Kept as a method rather
   * than deleted because `setStep`, `paintTabs` and `editPick` all ask it,
   * and one honest `true` is clearer than three deletions. */
  Builder.prototype.reachable = function () {
    return true;
  };

  /* ------------------------------------------------------------ picking -- */

  /* The name of one item, as the customer would say it. */
  Builder.prototype.nameOf = function (variantId) {
    var info = this.info(variantId);
    var label = info.p;
    if (info.v && info.v !== DEFAULT_TITLE) label += ' ' + DASH + ' ' + info.v;
    return label;
  };

  Builder.prototype.add = function (index, variantId, quantity, options) {
    var opts = options || {};
    var key = String(variantId);
    var want = quantity || 1;
    if (!this.steps[index]) return;

    var info = this.info(key);
    if (!info.available) {
      this.say(info.p + ' is not available at the moment.');
      this.render();
      return;
    }

    /* THE CAP, IF THE MERCHANT SET ONE. This is the cake step's "at most
     * one", and it is a flat refusal rather than a dialog: there is nothing
     * to offer. A larger box does not buy you a second cake. */
    if (!this.canAdd(index)) {
      this.say(
        'You can have at most ' +
          this.maxOf(index) +
          ' in ' +
          this.stepLabel(index) +
          '. Remove one before choosing another.'
      );
      this.render();
      return;
    }

    /* ONE WHOLE CAKE, however many kinds of cake the shop sells. A flat
     * refusal like the step cap above, and for the same reason: there is
     * nothing to offer. A larger box does not buy you a second cake. */
    var kind = this.kindOf(key);
    if (kind && this.atKindLimit(kind)) {
      this.say(
        'Your bundle already has ' +
          (this.classMax === 1 ? 'one' : this.classMax) +
          '. Take it out before choosing another.'
      );
      this.render();
      return;
    }

    var cap = this.maxOf(index);
    if (cap > 0) {
      var room = cap - this.count(index);
      if (want > room) want = room;
    }

    /* THE BUDGET. Not a refusal and not a greyed-out button: an item that
     * will not fit opens the dialog, which is the only place the customer is
     * offered a way forward — a larger size, or the item on its own line.
     * `opts.forced` is how the dialog's own "change up" action comes back
     * through here once the size has actually moved. */
    if (!opts.forced && !this.fits(key, want)) {
      this.promptOverBudget(index, key, want, opts.trigger || null);
      return;
    }

    var list = this.picks[index];
    var existing = null;
    list.forEach(function (pick) {
      if (pick.id === key) existing = pick;
    });
    if (existing) {
      existing.qty += want;
    } else {
      list.push({ id: key, qty: want });
    }

    this.say(
      this.nameOf(key) +
        ' added. ' +
        this.stepLabel(index) +
        ': ' +
        this.count(index) +
        ' chosen. Your bundle is ' +
        this.fullness() +
        '% full.'
    );
    this.clearError();
    this.render();
  };

  Builder.prototype.remove = function (index, variantId, all) {
    var key = String(variantId);
    var list = this.picks[index] || [];
    var kept = [];
    var info = this.info(key);
    var changed = false;

    list.forEach(function (pick) {
      if (pick.id !== key) {
        kept.push(pick);
        return;
      }
      changed = true;
      if (!all && pick.qty > 1) {
        pick.qty -= 1;
        kept.push(pick);
      }
    });

    if (!changed) return;
    this.picks[index] = kept;

    this.say(
      this.nameOf(key) +
        ' removed. ' +
        this.stepLabel(index) +
        ': ' +
        this.count(index) +
        ' chosen. Your bundle is ' +
        this.fullness() +
        '% full.'
    );
    this.clearError();
    this.render();
  };

  /* --------------------------------------------------------- the extras --
   * An item taken anyway on the largest size. It lives here and nowhere
   * else: not in `picks`, not in the payload, not in the budget. */

  Builder.prototype.addExtra = function (variantId, quantity) {
    var key = String(variantId);
    var want = quantity || 1;
    var existing = null;
    this.extras.forEach(function (extra) {
      if (extra.id === key) existing = extra;
    });
    if (existing) existing.qty += want;
    else this.extras.push({ id: key, qty: want });

    this.say(
      this.nameOf(key) +
        ' will be added to your basket on its own, at ' +
        this.formatMoney(this.info(key).price) +
        '. It is not part of the bundle.'
    );
    this.clearError();
    this.render();
  };

  Builder.prototype.removeExtra = function (variantId, all) {
    var key = String(variantId);
    var kept = [];
    var changed = false;
    this.extras.forEach(function (extra) {
      if (extra.id !== key) {
        kept.push(extra);
        return;
      }
      changed = true;
      if (!all && extra.qty > 1) {
        extra.qty -= 1;
        kept.push(extra);
      }
    });
    if (!changed) return;
    this.extras = kept;
    this.say(this.nameOf(key) + ' will no longer be added on its own.');
    this.clearError();
    this.render();
  };

  /* ------------------------------------------------------- the dialog --
   * INLINE, NEVER window.confirm AND NEVER window.alert. The shell is in
   * the document from first paint (see the section); only the title, the
   * body and the actions are written here. The idiom, the focus handling
   * and the "dismissal is an answer" rule are assets/ibc-gift-box.js's
   * `openPrompt`, which this deliberately mirrors rather than reinvents. */

  Builder.prototype.openDialog = function (config) {
    var self = this;
    if (!this.dialog || !this.dialogPanel) {
      /* No dialog in the markup — an older section, a stripped page. Say it
       * instead. There is still no window.confirm anywhere in this file. */
      this.say(config.fallback || config.title || '');
      return;
    }

    /* Never stack two, and never fire the outgoing one's dismissal as a side
     * effect of opening the next. */
    this.closeDialog({ silent: true });

    this.dialogTrigger =
      config.trigger && config.trigger.focus ? config.trigger : document.activeElement;

    if (this.dialogTitle) this.dialogTitle.textContent = config.title || '';
    if (this.dialogBody) {
      while (this.dialogBody.firstChild) this.dialogBody.removeChild(this.dialogBody.firstChild);
      (config.body || []).forEach(function (line) {
        var para = el('p', null);
        para.textContent = line;
        self.dialogBody.appendChild(para);
      });
    }

    this._actions = [];
    if (this.dialogActions) {
      while (this.dialogActions.firstChild) {
        this.dialogActions.removeChild(this.dialogActions.firstChild);
      }
      (config.actions || []).forEach(function (action) {
        var at = self._actions.length;
        self._actions.push(action);
        var button = el(
          'button',
          'ibcb__dialog-btn ibcb__dialog-btn--' + (action.kind || 'ghost')
        );
        button.type = 'button';
        button.textContent = action.label;
        /* Dispatched by index through the ONE delegated listener on the
         * root. No per-node listener is ever added, so replacing the panel's
         * contents cannot leak one. */
        button.setAttribute('data-ibcb-dialog-action', String(at));
        self.dialogActions.appendChild(button);
      });
    }

    this.dialog.hidden = false;
    this.el.classList.add('is-dialog');
    /* NOT announced through the live region. The panel is focused and
     * carries aria-labelledby and aria-describedby, so a screen reader reads
     * the title and the body on arrival; saying it again through the polite
     * region would read the whole dialog twice. */
    try {
      this.dialogPanel.focus({ preventScroll: true });
    } catch (error) {
      this.dialogPanel.focus();
    }
  };

  Builder.prototype.closeDialog = function (options) {
    var opts = options || {};
    if (!this.dialog || this.dialog.hidden) return;
    this.dialog.hidden = true;
    this.el.classList.remove('is-dialog');

    var trigger = this.dialogTrigger;
    this.dialogTrigger = null;
    this._actions = [];

    /* Focus goes back where it came from — the "+" or the Add control the
     * customer pressed. Wrapped because the card may have been re-rendered
     * away underneath the dialog. */
    if (!opts.silent && trigger && typeof trigger.focus === 'function') {
      try {
        trigger.focus();
      } catch (error) {
        /* the trigger has gone; the panel is closed either way */
      }
    }
  };

  Builder.prototype.trapDialog = function (event) {
    if (!this.dialogPanel || !this.dialog || this.dialog.hidden) return;
    var nodes = toArray(this.dialogPanel.querySelectorAll(FOCUSABLE)).filter(function (node) {
      return node.offsetWidth > 0 || node.offsetHeight > 0 || node === document.activeElement;
    });
    if (!nodes.length) {
      event.preventDefault();
      this.dialogPanel.focus();
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || active === this.dialogPanel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  };

  /* --------------------------------------------------- over budget -----
   * TWO SITUATIONS AND ONLY TWO, and which one it is depends on whether the
   * customer is standing on the LARGEST size — determined by price
   * ascending, never by a variant title and never by an id in a list.
   *
   * Not the largest: offer to change UP. Every existing selection comes
   * across untouched, because changing the size changes `sizeId` and
   * nothing else — `picks` is not read, not rebuilt and not cleared by
   * `chooseSize`. There is deliberately NO downgrade offered anywhere: it
   * would mean deciding which of the customer's choices to throw away.
   *
   * The largest: offer the item ANYWAY, at its own full price, WITH THAT
   * PRICE SHOWN, as an ordinary separate basket line.
   *
   * Cancel, Escape, the scrim and the close button all mean the same thing
   * and all do the same thing: nothing is added. */

  /* WHICH HAMPER GOES WITH THE SIZE THE CUSTOMER IS ON.
   *
   * By title first: a hamper variant called "Large" belongs to the bundle
   * size called "Large". That is a contract between two products, so it is
   * matched loosely — trimmed and case-folded — and it never throws when it
   * fails. By position second, since the sizes are in order and so are the
   * hamper's variants as the admin lists them. By the first variant last, so
   * a one-variant hamper works against any number of sizes. */
  Builder.prototype.hamperVariant = function () {
    if (!this.hasHamper) return null;
    var size = this.currentSize();
    var wanted = String((size && size.title) || '').trim().toLowerCase();
    var found = null;
    if (wanted) {
      this.hamperVariants.forEach(function (variant) {
        if (found) return;
        if (String(variant.title || '').trim().toLowerCase() === wanted) found = variant;
      });
    }
    if (found) return found;
    var at = this.sizeIndex();
    if (at > -1 && this.hamperVariants[at]) return this.hamperVariants[at];
    return this.hamperVariants[0] || null;
  };

  /* WHAT THE CUSTOMER CALLS IT. The shop's setting first, the product's own
   * title only as a fallback: the product has to be called something in the
   * admin and that something does not have to be what anybody reads. */
  Builder.prototype.hamperName = function () {
    return this.hamperLabel || (this.hamper && this.hamper.title) || 'Wicker basket';
  };

  /* What the hamper adds, in minor units. 0 when none is wanted, so it can be
   * added to a total without asking first. */
  Builder.prototype.hamperPence = function () {
    if (!this.hamperOn) return 0;
    var variant = this.hamperVariant();
    return variant ? parseInt(variant.price, 10) || 0 : 0;
  };

  /* WHAT THE BUNDLE COSTS: the chocolates plus the hamper. The header line is
   * not in here because it is GBP 0 — the box is included — and if the shop
   * ever charges for packing, that charge is the header's own variant price
   * and Shopify will add it to the basket without this file's help. */
  Builder.prototype.total = function () {
    return this.spent() + this.hamperPence();
  };

  Builder.prototype.chooseHamper = function (on) {
    var want = !!on;
    var variant = this.hamperVariant();

    if (want && (!variant || variant.available === false)) {
      /* Not silently ignored, and not left looking chosen. Sold out is a fact
       * about the shop, and the customer is told it rather than finding out
       * at the checkout. */
      this.hamperOn = false;
      this.showError(
        this.hamperName() + ' is not available just now. Your bundle will come in our own box.'
      );
      this.render();
      return;
    }

    this.hamperOn = want;
    this.clearError();
    this.render();
    this.say(
      want
        ? this.hamperName() +
            ' added, ' +
            (variant.priceFormatted || this.formatMoney(variant.price)) +
            '.'
        : 'No hamper. Your bundle comes in our own box.'
    );
  };

  Builder.prototype.sizeIndex = function () {
    var key = String(this.sizeId);
    var at = -1;
    this.sizes.forEach(function (size, i) {
      if (String(size.id) === key) at = i;
    });
    return at;
  };

  /* The next entry up the price order. Null on the largest — which is also
   * null when there is only one size, and that is the right answer: a
   * one-variant bundle IS its own largest. */
  Builder.prototype.nextLarger = function () {
    var at = this.sizeIndex();
    if (at === -1) return null;
    var here = this.sizes[at];
    var mine = parseInt(here.capacity, 10) || 0;
    var i;
    for (i = at + 1; i < this.sizes.length; i += 1) {
      var theirs = parseInt(this.sizes[i].capacity, 10) || 0;
      /* More room, when the shop has said how much room there is. Otherwise
       * more money, which is what "larger" meant before capacity existed —
       * and on a shop that has neither there is no larger size, which is the
       * honest answer and also a harmless one: with nothing sized, nothing
       * is ever refused, so the upgrade is never offered anyway. */
      if (mine > 0 ? theirs > mine : (this.sizes[i].price || 0) > (here.price || 0)) {
        return this.sizes[i];
      }
    }
    return null;
  };

  Builder.prototype.promptOverBudget = function (index, variantId, want, trigger) {
    var self = this;
    var info = this.info(variantId);
    var larger = this.nextLarger();
    var name = this.nameOf(variantId);

    if (larger) {
      this.openDialog({
        trigger: trigger,
        title: 'That will not fit this size',
        body: [
          name + ' needs more room than is left in the ' + this.sizeName() + '.',
          'Move up to the ' +
            (larger.title || 'next size') +
            ' at ' +
            (larger.priceFormatted || this.formatMoney(larger.price)) +
            ' and everything you have already chosen comes with you.'
        ],
        actions: [
          {
            kind: 'primary',
            label: 'Change to the ' + (larger.title || 'next size'),
            run: function () {
              self.chooseSize(larger.id);
              /* Re-asked rather than forced: the larger size may still not
               * hold it, in which case the customer meets this dialog again
               * one size up — and on the largest they are offered the item
               * on its own line. Nothing is added behind their back. */
              self.add(index, variantId, want, { trigger: trigger });
            }
          },
          { kind: 'ghost', label: 'Not this one' }
        ],
        fallback:
          name + ' will not fit. Choose a larger size, or take something else out.'
      });
      return;
    }

    /* THE LARGEST SIZE, AND NO ESCAPE HATCH. The shop has asked for a hard
     * cap, so there is nothing to offer and the dialog says so plainly rather
     * than inventing a way forward. It points at the review instead, which is
     * where the customer goes next if they are finished — "capped, and
     * prompted to check out". */
    if (!this.allowExtras) {
      this.openDialog({
        trigger: trigger,
        title: 'Your bundle is full',
        body: [
          'This is the largest size, and ' + name + ' will not fit what is left.',
          'Take something out to make room for it, or go on to review what you have.'
        ],
        actions: [
          {
            kind: 'primary',
            label: 'Review my bundle',
            run: function () {
              self.openReview();
            }
          },
          { kind: 'ghost', label: 'Keep choosing' }
        ],
        fallback:
          name + ' will not fit, and this is the largest size. Take something out to make room.'
      });
      return;
    }

    /* THE LARGEST SIZE. The only way forward is to buy it separately, and
     * the price of doing so is the first thing the dialog says. */
    var cost = this.formatMoney(info.price * want);
    this.openDialog({
      trigger: trigger,
      title: 'Your bundle is full',
      body: [
        'This is the largest size, and ' + name + ' will not fit what is left.',
        'We can add it to your basket on its own for ' +
          cost +
          '. It will be a separate item, at its own price, and not part of the bundle.'
      ],
      actions: [
        {
          kind: 'primary',
          label: 'Add it separately for ' + cost,
          run: function () {
            self.addExtra(variantId, want);
          }
        },
        { kind: 'ghost', label: 'No thank you' }
      ],
      fallback:
        name + ' will not fit, and this is the largest size. Take something out to make room.'
    });
  };

  /* ---------------------------------------------------------- announcing -- */

  Builder.prototype.say = function (message) {
    if (!this.live) return;
    this.live.textContent = message || '';
  };

  Builder.prototype.showError = function (message) {
    this.errorBoxes.forEach(function (box) {
      box.textContent = message || '';
      box.hidden = !message;
    });
    if (message) this.say(message);
  };

  Builder.prototype.clearError = function () {
    this.errorBoxes.forEach(function (box) {
      if (!box.textContent) return;
      box.textContent = '';
      box.hidden = true;
    });
  };

  /* --------------------------------------------------------- the size --
   * THE ONE DOOR TO A SIZE CHANGE, and it goes through the page's own
   * product controller first so the variant picker, the price and the
   * gallery move with it. The idiom is assets/ibc-gift-box.js `chooseSize`,
   * and so is the guard: `window.IbcProduct.select` is called only when it
   * is actually there. Every tile is a real `?variant=` link, so when it is
   * not there the click is never intercepted, the browser navigates, and
   * Liquid re-renders the builder against the new variant. Nothing is lost
   * and no control is ever dead.
   *
   * NOTHING ELSE HAPPENS HERE. `picks` and `extras` are not read, not
   * rebuilt and not cleared — which is precisely what makes "change up and
   * everything comes with you" true rather than a promise. */

  Builder.prototype.chooseSize = function (variantId, options) {
    var opts = options || {};
    var key = String(variantId);
    var known = null;
    this.sizes.forEach(function (size) {
      if (String(size.id) === key) known = size;
    });
    if (!known) return;

    if (window.IbcProduct && typeof window.IbcProduct.select === 'function') {
      try {
        window.IbcProduct.select(this.bundle.productId, known.id);
      } catch (error) {
        /* The page's controller refused. The builder still knows which size
         * it is on, so the flow carries on; only the page furniture is out
         * of step, and a reload puts that right. */
      }
    }

    this.setSize(known.id, opts);
  };

  /* Reconcile the builder to a variant id, whether the change came from a
   * tile here or from the page's own picker through `ibc:product-selection`.
   * Separate from `chooseSize` so that answering the page does not bounce
   * straight back out to it. */
  Builder.prototype.setSize = function (variantId, options) {
    var opts = options || {};
    var key = String(variantId);
    if (key === String(this.sizeId)) {
      this.render();
      return;
    }
    var known = null;
    this.sizes.forEach(function (size) {
      if (String(size.id) === key) known = size;
    });
    if (!known) return;

    this.sizeId = key;
    /* The bundle line that will actually be added. `bundle.variantId` is
     * what `commit()` posts, so it has to move with the size or the customer
     * would be charged for whatever size Liquid happened to render. */
    this.bundle.variantId = known.id;
    this.bundle.price = known.price;

    this.render();
    if (!opts.silent) {
      this.say(
        (known.title || 'Size') +
          ' chosen, ' +
          (known.priceFormatted || this.formatMoney(known.price)) +
          '. Your bundle is ' +
          this.fullness() +
          '% full.'
      );
    }
  };

  Builder.prototype.sizeName = function () {
    var size = this.currentSize();
    return (size && size.title) || this.bundle.title || 'this size';
  };

  /* BRING A STAGE INTO VIEW ONLY IF IT IS NOT ALREADY THERE.
   *
   * Both stages used to call `scrollIntoView({ block: 'start' })` on every
   * move, unconditionally. On the desktop hero layout the whole step already
   * fits the screen, so pressing Continue scrolled a page that had nothing
   * to scroll to: the title and the photograph slid up out of view and the
   * customer was dropped into the middle of a page they had been looking at
   * the top of. That is the "screen shifts down" this fixes.
   *
   * The test is the honest one -- is the stage inside the viewport already?
   * -- so the taller item steps further on still scroll, because they are
   * not. `focus` takes `preventScroll` in the branch that decided not to
   * move, because focusing an element scrolls to it too, and a second
   * mechanism undoing the first is how this sort of thing comes back. */
  Builder.prototype.revealStage = function (el) {
    if (!el) return;
    var box = el.getBoundingClientRect();
    var inView = box.top >= 0 && box.bottom <= (window.innerHeight || 0) + 1;

    if (!inView && el.scrollIntoView) {
      el.scrollIntoView({
        behavior: reducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
      if (el.focus) el.focus();
      return;
    }

    if (!el.focus) return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  };

  Builder.prototype.openSize = function (options) {
    var opts = options || {};
    if (!this.sizeStage) return;
    if (this.reviewOpen) {
      this.reviewOpen = false;
      if (this.review) this.review.hidden = true;
      this.el.classList.remove('is-review');
    }
    /* THE MIRROR OF THE GUARD IN `openPres`, AND IT WAS MISSING.
     * Both stages stand in the panels' place, so only one of them may be
     * open. `openPres` has always closed the size stage; `openSize` never
     * closed the presentation stage, so going BACK from the basket to the
     * size -- by the tab, which is the obvious way -- left the root carrying
     * `is-pres is-size` and both stages on screen at once, one under the
     * other. The asymmetry was invisible until the basket step became
     * reachable from a tab of its own. */
    if (this.presOpen) {
      this.presOpen = false;
      if (this.presStage) this.presStage.hidden = true;
      this.el.classList.remove('is-pres');
    }
    this.sizeOpen = true;
    this.closeTray({ silent: true });
    this.render();
    if (opts.silent) return;

    this.revealStage(this.sizeStage);
    this.say(
      'Choose your size. You are on the ' +
        this.sizeName() +
        '. Nothing you have chosen is lost by changing it.'
    );
  };

  Builder.prototype.closeSize = function (options) {
    var opts = options || {};
    if (!this.sizeOpen) return;
    this.sizeOpen = false;
    if (this.sizeStage) this.sizeStage.hidden = true;
    if (opts.silent) {
      this.render();
      return;
    }
    /* THE STAGE AFTER THE SIZE IS THE PRESENTATION, when there is one. Every
     * time, not just the first: it is a stage in the path rather than a
     * question asked once, so coming back to change the size and going
     * forward again passes through it again — and it has to, because the
     * hamper's price has just changed with the size. */
    if (this.presStage) {
      this.openPres();
      return;
    }
    this.setStep(Math.min(this.step, Math.max(0, this.steps.length - 1)));
  };

  Builder.prototype.paintSize = function () {
    var self = this;
    if (!this.sizeStage) return;
    this.sizeStage.hidden = !this.sizeOpen;
    this.el.classList.toggle('is-size', this.sizeOpen);

    toArray(this.el.querySelectorAll('[data-ibcb-size-tile]')).forEach(function (tile) {
      var mine = String(tile.getAttribute('data-ibcb-variant-id')) === String(self.sizeId);
      if (mine) tile.setAttribute('aria-current', 'true');
      else tile.removeAttribute('aria-current');
      tile.classList.toggle('is-current', mine);
    });

    /* THE SIZE ITEM IS ONE OF THE FOUR NOW, so it is painted like the other
     * three and not like a control that happens to live near them.
     *
     * Its value span used to print the size's NAME ("Large"), which is what
     * made it wider than the three beside it and is a large part of why the
     * fourth item would not fit on a phone. The name is not lost: it is the
     * heading of the size stage the item opens, and the size stage is one tap
     * away. What the span carries instead is nothing — the tick comes from
     * `is-done` on the button, exactly as it does for Cake, Favourites and
     * Treats, and `.ibcb__steps-c:empty` closes the gap it would leave.
     *
     * DONE MEANS "PASSED THROUGH", not "has a value". A size id is set from
     * the first paint (the product's own default variant), so ticking on the
     * id alone would tick before the customer had done anything. The item is
     * done once they have left the stage, which is the same reading the other
     * three get: something happened here. */
    var value = this.el.querySelector('[data-ibcb-size-tab-value]');
    if (value) value.textContent = '';

    /* WHICH SIZE IS CHOSEN, IN WORDS, KEPT CURRENT.
     * Liquid writes the first value into `[data-ibcb-size-chosen]`, but
     * choosing a size does not reload this section -- the row is a real
     * ?variant= link whose click is intercepted -- so the sentence would
     * otherwise go on naming whichever variant the page happened to load
     * with. The label is read off the chosen row rather than from a second
     * table, so there is one source for it and it cannot drift. */
    var chosen = this.el.querySelector('[data-ibcb-size-chosen]');
    if (chosen) {
      var current = this.el.querySelector('[data-ibcb-size-tile][aria-current="true"]');
      var label = current ? (current.getAttribute('data-label') || '') : '';
      chosen.textContent = label ? label + ' selected' : '';
      chosen.hidden = !label;
    }

    var tab = this.el.querySelector('[data-ibcb-size-tab]');
    if (tab) {
      if (this.sizeOpen) tab.setAttribute('aria-current', 'step');
      else tab.removeAttribute('aria-current');
      tab.classList.toggle('is-done', !this.sizeOpen && !!this.sizeId);
    }
  };

  /* -------------------------------------------------------------- steps -- */

  /* THE WAY BACK FROM THE PERSISTENT BAR. One control, and where it goes
   * depends only on where the customer is: out of the review to the step
   * they left, back a step, and from the first step to the size stage when
   * there is one. It hides itself when there is genuinely nowhere behind. */
  Builder.prototype.openPres = function (options) {
    var opts = options || {};
    if (!this.presStage) return;
    if (this.reviewOpen) {
      this.reviewOpen = false;
      if (this.review) this.review.hidden = true;
      this.el.classList.remove('is-review');
    }
    if (this.sizeOpen) {
      this.sizeOpen = false;
      if (this.sizeStage) this.sizeStage.hidden = true;
      this.el.classList.remove('is-size');
    }
    this.presOpen = true;
    this.closeTray({ silent: true });
    this.render();
    if (opts.silent) return;

    this.revealStage(this.presStage);
    var variant = this.hamperVariant();
    this.say(
      'Box or hamper. ' +
        (this.hamperOn
          ? 'You have chosen the ' + this.hamperName() + '.'
          : 'Your bundle comes in our own box.') +
        (variant
          ? ' The ' +
            this.hamperName() +
            ' for this size is ' +
            (variant.priceFormatted || this.formatMoney(variant.price)) +
            '.'
          : '')
    );
  };

  Builder.prototype.closePres = function (options) {
    var opts = options || {};
    if (!this.presOpen) return;
    this.presOpen = false;
    this.seenPres = true;
    if (this.presStage) this.presStage.hidden = true;
    if (opts.silent) {
      this.render();
      return;
    }
    this.setStep(Math.min(this.step, Math.max(0, this.steps.length - 1)));
  };

  Builder.prototype.backTarget = function () {
    if (this.sizeOpen) return null;
    /* The presentation stage sits between the size and the first step, so
     * back from it is the size and back from the first step is it. */
    if (this.presOpen) return this.sizeStage ? { kind: 'size' } : null;
    if (this.reviewOpen) return { kind: 'step', index: Math.min(this.reviewFrom, this.steps.length - 1) };
    if (this.step > 0) return { kind: 'step', index: this.step - 1 };
    if (this.presStage) return { kind: 'pres' };
    if (this.sizeStage) return { kind: 'size' };
    return null;
  };

  Builder.prototype.goBack = function () {
    var target = this.backTarget();
    if (!target) return;
    if (target.kind === 'size') {
      this.openSize();
      return;
    }
    if (target.kind === 'pres') {
      this.openPres();
      return;
    }
    if (this.reviewOpen) {
      this.closeReview();
      return;
    }
    this.setStep(target.index);
  };

  /* THE CAKE IS OPTIONAL. "Skip" is not a special stage and not a state: it
   * is simply moving on without having chosen, which nothing prevents. It
   * exists as its own control because Continue does not read as permission
   * to leave a step empty, and a customer who wants more treats should not
   * have to work that out. */
  Builder.prototype.skipStep = function (index) {
    var at = typeof index === 'number' ? index : this.step;
    this.say(
      this.stepLabel(at) + ' skipped. There is more room for everything else.'
    );
    if (at + 1 < this.steps.length) this.setStep(at + 1);
    else this.openReview();
  };

  Builder.prototype.setStep = function (index, options) {
    var opts = options || {};
    if (index < 0 || index >= this.steps.length) return;
    if (this.sizeOpen) {
      this.sizeOpen = false;
      if (this.sizeStage) this.sizeStage.hidden = true;
      this.el.classList.remove('is-size');
    }
    if (this.reviewOpen) this.closeReview({ silent: true });
    /* Reaching a step any other way than an Edit control means the customer
     * has chosen the ordinary flow, so the promise to go back to the review
     * is off. `editPick` passes keepReturn and sets it again afterwards. */
    if (!opts.keepReturn) this.reviewReturn = false;
    this.step = index;
    this.render();

    var panel = this.panels[index];
    if (panel && !opts.silent) {
      panel.focus();
      if (panel.scrollIntoView) {
        panel.scrollIntoView({
          behavior: reducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });
      }
      this.say(
        this.stepLabel(index) +
          '. ' +
          this.count(index) +
          ' chosen. Your bundle is ' +
          this.fullness() +
          '% full.'
      );
    }
  };

  /* `revealTab()` HAS GONE WITH THE SCROLLER. It nudged `scrollLeft` to bring
   * the current step into view on a strip that was `overflow-x: auto`; the
   * strip now shrinks to fit all four items at 360px and cannot scroll, so
   * the function had nothing left to do and every call site would have been a
   * no-op. Deleted rather than left as a guard for a scroller that is not
   * coming back — see the arithmetic in assets/ibc-bundle.css. */

  /* ------------------------------------------------ the advance control --
   * THREE VIEWS, ONE CONTROL. The button in the step's nav row, the one in
   * the step's heading on desktop, and the one on the mobile bar all carry
   * `data-ibcb-next` and the same pair of label attributes. `paintAdvance`
   * paints every one of them and `advance` handles every one of them; there
   * is no second implementation of "go on" anywhere in this file. */

  /* Which step a given advance control speaks for: the one it sits inside,
   * or the current step when it is furniture outside the panels. */
  Builder.prototype.advanceIndex = function (control) {
    var panel = control && control.closest ? control.closest('[data-ibcb-panel]') : null;
    if (!panel) return this.step;
    return parseInt(panel.getAttribute('data-ibcb-index'), 10) || 0;
  };

  /* True when this control opens the review rather than moving on: the last
   * step, or any step the customer reached from a review Edit. */
  Builder.prototype.reviewsFrom = function (index) {
    if (!this.steps.length) return false;
    return this.reviewReturn || index >= this.steps.length - 1;
  };

  /* THERE IS NO GATE ANY MORE. A step could only be left when it held
   * exactly its quota; the quota has gone with the budget rework and the
   * brief is explicit that all three steps are navigable at all times, so
   * every step may always be left. Kept as a method — rather than ripped out
   * of `advance` and `paintAdvance` — because it is the one place this fact
   * is stated, and because a shop that ever wants a gate back has one
   * function to write. */
  Builder.prototype.canLeave = function (index) {
    return !this.hasGone(index);
  };

  /* The one sentence the panel note, the bar's hidden note and the summary's
   * hidden note all carry. Nothing blocks moving on now, so it speaks only
   * of a real problem: something chosen has sold out. It is NOT a reason the
   * customer cannot continue — they can — it is a reason they cannot buy. */
  Builder.prototype.blockReason = function (index) {
    if (this.hasGone(index)) {
      return 'One of these is no longer available — swap it before you add the bundle.';
    }
    return '';
  };

  /* What to put the cursor on when the customer presses a Continue that
   * cannot advance: the first control that would actually fix the step. */
  Builder.prototype.repairTarget = function (index) {
    var self = this;
    var panel = this.panels[index];
    if (!panel) return null;
    /* "Short" used to mean "below the quota", and the quota has gone. The
     * only thing that stops a step being left now is a sold-out item in it,
     * so the repair is always a way to take one OUT, never a way to put one
     * in — hence false rather than a test. The add branch below is kept
     * because `repairTarget` is a general answer and the day a shop adds a
     * gate back it will want it. */
    var short = false;
    var cards = toArray(panel.querySelectorAll('[data-ibcb-card]'));
    var found = null;

    cards.forEach(function (card) {
      if (found) return;
      var vid = self.cardVariant(card);
      var info = vid ? self.info(vid) : null;
      var picked = vid ? self.qtyOf(index, vid) > 0 : false;
      if (short) {
        /* Somewhere to add one: the first card that is not sold out. */
        if (!info || !info.available) return;
        var add = card.querySelector('[data-ibcb-add]');
        var inc = card.querySelector('[data-ibcb-inc]');
        var pick = add && !add.hidden && !add.disabled ? add : inc;
        if (pick && !pick.hidden && !pick.disabled) found = pick;
      } else if (picked) {
        /* Too many, or one has gone: somewhere to take one away. */
        var dec = card.querySelector('[data-ibcb-dec]');
        if (dec && !dec.disabled) found = dec;
      }
    });

    return found || panel;
  };

  /* ONE handler for all three views. */
  Builder.prototype.advance = function (control) {
    var index = this.advanceIndex(control);
    if (!this.steps.length) return;

    /* On the size stage, "go on" means "leave the size stage". The two
     * controls that stand outside the panels — the summary's and the mobile
     * bar's — are on screen while it is open, and without this they would
     * advance a step the customer cannot see. */
    if (this.sizeOpen) {
      this.closeSize();
      return;
    }

    /* Same again for the presentation stage: it stands in the panels' place,
     * so the two controls that live outside them would otherwise advance a
     * step the customer cannot see. */
    if (this.presOpen) {
      this.closePres();
      return;
    }

    if (!this.canLeave(index)) {
      /* Not a dead end. The control is aria-disabled rather than disabled
       * precisely so that pressing it still does something: it says what is
       * wrong and puts the cursor on the thing that fixes it. */
      var reason = this.blockReason(index);
      if (this.step !== index) this.setStep(index, { silent: true });
      var target = this.repairTarget(index);
      this.say(this.stepLabel(index) + '. ' + reason);
      if (target && target.focus) {
        if (target.scrollIntoView) {
          target.scrollIntoView({
            behavior: reducedMotion() ? 'auto' : 'smooth',
            block: 'center'
          });
        }
        target.focus();
      }
      return;
    }

    if (this.reviewsFrom(index)) {
      this.openReview();
      return;
    }
    this.setStep(index + 1);
  };

  Builder.prototype.paintAdvance = function () {
    var self = this;
    toArray(this.el.querySelectorAll('[data-ibcb-next]')).forEach(function (control) {
      var index = self.advanceIndex(control);
      var toReview = self.reviewsFrom(index);
      var label = toReview
        ? control.getAttribute('data-ibcb-label-last')
        : control.getAttribute('data-ibcb-label-next');
      control.textContent = label || (toReview ? 'Review' : 'Continue');

      var blocked = !self.steps.length || !self.canLeave(index);
      if (blocked) {
        control.setAttribute('aria-disabled', 'true');
      } else {
        control.removeAttribute('aria-disabled');
      }
    });

    /* The controls that sit outside the panels — the mobile bar's and the
     * summary's — cannot point at a panel note for their reason. Each gets
     * its own hidden one, and both say the same sentence, from one call. */
    var reason = this.steps.length ? this.blockReason(this.step) : '';
    this.floatNotes.forEach(function (note) {
      note.textContent = reason;
    });
  };

  /* ------------------------------------------------------------ painting -- */

  Builder.prototype.render = function () {
    this.paintSize();
    this.paintPres();
    this.paintTotal();
    this.paintPanels();
    this.paintTabs();
    this.paintProgress();
    this.paintCards();
    this.paintCardPrices();
    this.paintSummary();
    this.paintReview();
    this.paintAdvance();
    this.paintBuy();
  };

  /* ---------------------------------------------------- the progress bar --
   * HOW FULL, NEVER HOW MUCH. Every `[data-ibcb-progress]` in the section is
   * painted from this one walk — the prominent one above the steps bar, the
   * compact one in the summary and the hairline one on the mobile bar — so
   * there is no second implementation and nothing is paired by position.
   *
   * The percentage is money underneath, and it is deliberately not spoken as
   * money: the customer chose the price on the size tile and will meet it
   * again at the review, and a running total between those two turns
   * choosing chocolates into accounting. */
  Builder.prototype.paintProgress = function () {
    var pct = this.fullness();
    var extras = this.extraCount();
    var chosen = this.totalChosen();

    var text;
    if (!chosen) {
      text = 'Nothing chosen yet.';
    } else if (pct >= 100) {
      text = 'Your bundle is full — ' + chosen + (chosen === 1 ? ' item.' : ' items.');
    } else {
      text = 'Your bundle is ' + pct + '% full — ' + chosen + (chosen === 1 ? ' item.' : ' items.');
    }
    if (extras) {
      text += ' ' + extras + (extras === 1 ? ' item' : ' items') + ' added separately.';
    }

    toArray(this.el.querySelectorAll('[data-ibcb-progress]')).forEach(function (box) {
      var label = box.querySelector('[data-ibcb-progress-text]');
      var rail = box.querySelector('[data-ibcb-progress-rail]');
      var fill = box.querySelector('[data-ibcb-progress-fill]');
      if (label) label.textContent = text;
      if (rail) {
        rail.setAttribute('aria-valuenow', String(pct));
        /* A percentage is not a sentence, so the rail also carries one for
         * anyone reading the value on its own. */
        rail.setAttribute('aria-valuetext', pct + '% full');
      }
      if (fill) fill.style.width = pct + '%';
      box.classList.toggle('is-full', pct >= 100);
    });
  };

  Builder.prototype.paintPres = function () {
    var self = this;
    if (!this.presStage) return;
    this.presStage.hidden = !this.presOpen;
    this.el.classList.toggle('is-pres', this.presOpen);

    /* THE PRICE IS PAINTED, NEVER RENDERED. It belongs to the hamper variant
     * that matches the size the customer is on, and the size can change long
     * after this stage was passed. */
    var variant = this.hamperVariant();
    var price = this.el.querySelector('[data-ibcb-hamper-price]');
    if (price) {
      price.textContent = variant
        ? '+ ' + (variant.priceFormatted || this.formatMoney(variant.price))
        : '';
    }
    var out = this.el.querySelector('[data-ibcb-hamper-out]');
    if (out) out.hidden = !variant || variant.available !== false;

    toArray(this.el.querySelectorAll('[data-ibcb-pres-tile]')).forEach(function (tile) {
      var wants = tile.getAttribute('data-ibcb-hamper') === 'true';
      var mine = wants === self.hamperOn;
      if (mine) tile.setAttribute('aria-current', 'true');
      else tile.removeAttribute('aria-current');
      tile.classList.toggle('is-current', mine);
    });

    var value = this.el.querySelector('[data-ibcb-pres-tab-value]');
    if (value) value.textContent = '';

    var tab = this.el.querySelector('[data-ibcb-pres-tab]');
    if (tab) {
      if (this.presOpen) tab.setAttribute('aria-current', 'step');
      else tab.removeAttribute('aria-current');
      tab.classList.toggle('is-done', !this.presOpen && this.seenPres);
    }
  };

  /* THE RUNNING TOTAL, everywhere it appears, in one walk. Every copy of it
   * is found by attribute rather than held in a list built at start-up, for
   * the same reason `paintProgress` does: the mobile bar and the desktop
   * aside are the same component rendered twice, and pairing them by
   * position is how two copies of a number start disagreeing.
   *
   * SILENT ON AN EMPTY BUNDLE. "£0.00" before anything is chosen reads as a
   * price rather than as a starting point. */
  Builder.prototype.paintTotal = function () {
    var total = this.total();
    var text = total > 0 ? this.formatMoney(total) : '';
    /* `data-ibcb-money`, NOT `data-ibcb-total`. That name was already on the
     * `.ibcb__layout` div, which wraps the whole builder — so this walk set
     * the container's textContent and wiped every card, panel and stage off
     * the page on the first paint. The markup was always right; this line
     * deleted it. Check a new attribute name is free before painting into
     * one: `grep -c` in the section takes five seconds and this cost an
     * afternoon. */
    toArray(this.el.querySelectorAll('[data-ibcb-money]')).forEach(function (node) {
      node.textContent = text;
    });
  };

  Builder.prototype.paintPanels = function () {
    var self = this;
    this.panels.forEach(function (panel, i) {
      /* The review stage and the size stage both stand in the panels' place,
       * so while either is open none of them is showing. */
      panel.hidden = self.reviewOpen || self.sizeOpen || self.presOpen || i !== self.step;

      var progress = panel.querySelector('[data-ibcb-panel-progress]');
      if (progress) {
        var n = self.count(i);
        var cap = self.maxOf(i);
        if (!n) {
          progress.textContent = cap === 1 ? 'None chosen — this one is optional.' : 'None chosen yet.';
        } else if (cap > 0) {
          progress.textContent = n + ' of ' + cap + ' chosen.';
        } else {
          progress.textContent = n + (n === 1 ? ' chosen.' : ' chosen.');
        }
      }

      /* The note is the spoken reason both of this panel's advance controls
       * point at with aria-describedby; `blockReason` is the single source
       * of that sentence, shared with the bar. */
      var note = panel.querySelector('[data-ibcb-panel-note]');
      var message = self.blockReason(i);
      if (note) {
        note.textContent = message;
        note.hidden = !message;
      }
    });
  };

  /* EVERY TAB IS ALWAYS LIVE. The numbers have gone from the markup and the
   * `n/N` tally has gone from here: with no quota there is no denominator to
   * print, so the tab carries a plain count of what is in that step and
   * nothing at all when it is empty. `tab.disabled` is never set — the brief
   * is explicit that all three are navigable at all times — so the `title`
   * that explained why a tab was shut has gone with it. */
  Builder.prototype.paintTabs = function () {
    var self = this;
    this.tabs.forEach(function (tab, i) {
      var n = self.count(i);
      var count = tab.querySelector('[data-ibcb-tab-count]');
      if (count) count.textContent = n > 0 ? String(n) : '';
      if (i === self.step && !self.reviewOpen && !self.sizeOpen && !self.presOpen) {
        tab.setAttribute('aria-current', 'step');
      } else {
        tab.removeAttribute('aria-current');
      }
      tab.classList.toggle('is-done', n > 0);
      tab.disabled = false;
      tab.removeAttribute('title');
    });

    /* THE WAY BACK, every copy of it, painted from the one `backTarget()`
     * answer so the accessible name, the visibility and what the control
     * actually does can never disagree.
     *
     * The visible word stays the merchant's ("Back") — it is short, and a
     * control beside Continue that grows to "Back to Favourites" would stop
     * being the quiet one. The ACCESSIBLE name says the destination, because
     * "Back" on its own, read out of the surrounding layout, is a control
     * whose meaning is entirely in pixels the listener cannot see. */
    var target = this.backTarget();
    var name = '';
    if (target) {
      if (target.kind === 'size') name = 'Back to ' + this.sizeTabLabel();
      else if (target.kind === 'pres') name = 'Back to ' + this.presTabLabel();
      else name = 'Back to ' + this.stepLabel(target.index);
    }
    this.stepBacks.forEach(function (control) {
      control.hidden = !target;
      if (name) control.setAttribute('aria-label', name);
      else control.removeAttribute('aria-label');
    });
  };

  /* What the size item on the steps bar is called, read off the markup so the
   * merchant's own wording reaches the back control's accessible name too. */
  /* What the presentation item on the steps bar is called, read off the
   * markup so the merchant's own wording reaches the back control's
   * accessible name too. The size's twin, for the same reason. */
  Builder.prototype.presTabLabel = function () {
    var tab = this.el.querySelector('[data-ibcb-pres-tab]');
    var label = tab ? tab.querySelector('.ibcb__steps-l') : null;
    var text = label ? (label.textContent || '').trim() : '';
    return text || 'Presentation';
  };

  Builder.prototype.sizeTabLabel = function () {
    var tab = this.el.querySelector('[data-ibcb-size-tab]');
    var label = tab ? tab.querySelector('.ibcb__steps-l') : null;
    var text = label ? (label.textContent || '').trim() : '';
    return text || 'Size';
  };

  Builder.prototype.paintCards = function () {
    var self = this;
    toArray(this.el.querySelectorAll('[data-ibcb-card]')).forEach(function (card) {
      var grid = card.closest('[data-ibcb-grid]');
      var index = grid ? parseInt(grid.getAttribute('data-ibcb-index'), 10) || 0 : 0;
      var variantId = self.cardVariant(card);
      var info = variantId ? self.info(variantId) : null;
      var qty = variantId ? self.qtyOf(index, variantId) : 0;

      var badge = card.querySelector('[data-ibcb-card-badge]');
      var qtyBox = card.querySelector('[data-ibcb-qty]');
      var addBtn = card.querySelector('[data-ibcb-add]');
      var incBtn = card.querySelector('[data-ibcb-inc]');
      var countEl = card.querySelector('[data-ibcb-count]');
      var note = card.querySelector('[data-ibcb-card-note]');

      /* THE PICTURE FOLLOWS THE OPTION. `cardVariant()` has just answered
       * "which variant is this card offering", including reading the
       * <select>, and this is the one place that answer is turned back into
       * a photograph. It runs on every paint, and the document-level `change`
       * listener on `[data-ibcb-variant-select]` calls `render()`, so
       * choosing an option repaints the image on the same tick as the badge
       * and the stepper. There is no second listener for the picture and no
       * chance of the two disagreeing. */
      self.swapCardImage(card, variantId, info);

      card.classList.toggle('is-chosen', qty > 0);

      if (badge) {
        badge.textContent = qty > 0 ? TIMES + qty : '';
        badge.hidden = qty < 1;
      }
      if (countEl) countEl.textContent = String(qty);
      if (qtyBox) qtyBox.hidden = qty < 1;
      if (addBtn) addBtn.hidden = qty > 0;

      /* EXTRAS ARE MARKED ON THE CARD, not only in the review. A customer
       * who agreed to buy something separately has to be able to see, at the
       * moment they are looking at it, that it is not in the bundle. */
      var extraQty = variantId ? self.qtyOfExtra(variantId) : 0;
      card.classList.toggle('is-extra', extraQty > 0);

      var reason = '';
      if (!info) {
        reason = 'This one cannot be chosen at the moment.';
      } else if (!info.available) {
        reason =
          info.v && info.v !== DEFAULT_TITLE
            ? info.v + ' is sold out — choose another option.'
            : 'Sold out.';
      }
      /* THE CAP SENTENCE HAS GONE FROM THE CARD.
       *
       * The one-line refusal that interpolated the cap and the step label was
       * printed under EVERY card in the step the moment the cap was reached —
       * forty copies of one sentence, saying a thing the customer had just
       * done on purpose. The template string is deleted, not hidden, so it
       * cannot be reached from anywhere.
       *
       * THE CAP ITSELF IS UNTOUCHED. `maxOf()`, `atCap()` and `canAdd()` are
       * exactly as they were, and `blocked` below still reads `!canAdd`, so a
       * second cake is still refused.
       *
       * WHAT SIGNALS THE REFUSAL NOW, since a silent cap would be worse than a
       * verbose one — two things that were already on the page:
       *   * the Add and "+" controls go `disabled`, which is a state, not a
       *     sentence: greyed to the eye and announced as unavailable by a
       *     screen reader, on the one control it is about rather than on all
       *     of them.
       *   * the panel's own progress line reads "1 of 1 chosen." whenever the
       *     step carries a cap (`paintPanels`), which states the cap once, in
       *     one place, whether or not it has been reached.
       * Nothing is lost that was not repetition.
       *
       * NO HELPER FELL OUT OF USE. `maxOf()` is still the cap itself and
       * `stepLabel()` still names steps in a dozen places, so neither is
       * removable; the string was the whole of the change. The `say()` at
       * `add()` — "You can have at most N in <step>." — is a DIFFERENT
       * sentence on a different path (a programmatic add, or a restore from
       * the cart) and is deliberately left: it is spoken once, on demand,
       * never painted onto the page. */
      /* WHICH SIZE IT NEEDS, on the few cards where that is the whole story.
       *
       * The note above is deliberately silent about things that will not fit
       * RIGHT NOW, because "this will not fit" under forty cards is noise and
       * the progress bar has already said how full the bundle is. This is a
       * different sentence: it is true of an EMPTY bundle, so it holds still
       * while the customer chooses, and it is true of very few items — a
       * whole cake, and nothing else at today's numbers. A customer looking
       * at cakes on a Standard should learn they need the Large here, not by
       * pressing Add and meeting a dialog. */
      if (!reason && variantId && self.capped()) {
        var needs = self.sizeNeededFor(variantId);
        if (needs && String(needs.id) !== String(self.sizeId) && !self.fitsEmpty(variantId)) {
          reason = 'Only fits the ' + (needs.title || 'larger size') + '.';
        }
      }

      if (extraQty > 0) {
        reason =
          (reason ? reason + ' ' : '') +
          TIMES +
          extraQty +
          ' of this is being added to your basket separately, at its own price.';
      }

      /* THE BUDGET NEVER DISABLES THIS BUTTON. An item that will not fit
       * leaves the control live and opens the over-budget dialog when it is
       * pressed — the same rule the gift box builder's "+" follows on a full
       * box. Greying it out would say "no" and offer nothing; the dialog
       * says "not at this size" and offers the two things that would work.
       * The note is deliberately silent about it too: a "this will not fit"
       * line under forty cards is noise, and the progress bar has already
       * said how full the bundle is. */
      var blocked = !info || !info.available || !self.canAdd(index);
      if (addBtn) addBtn.disabled = blocked;
      if (incBtn) incBtn.disabled = blocked;
      card.classList.toggle('is-out', !!info && !info.available);

      if (note) {
        note.textContent = reason;
        note.hidden = !reason;
      }
    });
  };

  /* The variant a card is currently offering: the <select> when this step has
   * real options to offer, and otherwise the card's own single qualifying
   * variant, named on the card as `data-ibcb-variant-id`.
   *
   * That attribute is what makes a one-variant STEP work. The product's first
   * variant is no longer the right answer — the treat step may offer only the
   * 50g bag, which is nowhere near first in the product's own list — so the
   * old `firstVariant` lookup survives only as a last resort, for a card from
   * some older render that carries no such attribute. */
  /* ONE IMAGE SWAP, USED BY EVERY CARD.
   *
   * `src` AND `srcset` MOVE TOGETHER OR NOT AT ALL. Setting `src` alone is
   * the whole of the original bug's second half: the browser goes on picking
   * a candidate out of the `srcset` that is still on the element, so the old
   * photograph wins and the swap looks like it did nothing. Both attributes
   * are written on every swap, and `srcset` is REMOVED rather than set to ''
   * when the variant has no candidate list — an empty `srcset` attribute is
   * a parse error's worth of ambiguity, an absent one is simply absent.
   *
   * NO LAYOUT SHIFT. `width`/`height` are re-stated from the new image's own
   * intrinsic dimensions, so the aspect box the card reserves is right for
   * the picture in it; the media box is a fixed ratio in CSS, so the grid
   * does not move either way.
   *
   * `loading="lazy"` IS LEFT EXACTLY AS IT WAS. It is honoured at the moment
   * the element is first laid out; re-asserting it on a swap does nothing,
   * and clearing it would turn every option change into an eager fetch of a
   * picture that may be well below the fold. A swap on an already-visible
   * card fetches immediately regardless, which is the behaviour wanted.
   *
   * Guarded on equality so a paint that changes nothing does not touch the
   * DOM — `render()` runs on every add, and a needless `src` write restarts
   * the decode. */
  Builder.prototype.swapCardImage = function (card, variantId, info) {
    var img = card.querySelector('.ibcb-card__img');
    if (!img || !variantId || !info || !info.image) return;

    /* THE GUARD IS THE VARIANT ID, NOT THE URL. Comparing `src` looked
     * obvious and was wrong: the server-rendered card asks for the picture at
     * 480w and the island carries it at 600w, so the same photograph has two
     * URLs and every first paint would have thrown away a picture the browser
     * had already fetched and decoded. The stamp says which variant the
     * element is currently showing, which is the question actually being
     * asked. Both renderers write it — see the snippet and `buildCard()`. */
    if (img.getAttribute('data-ibcb-img-variant') === String(variantId)) return;
    img.setAttribute('data-ibcb-img-variant', String(variantId));

    img.setAttribute('src', info.image);
    if (info.srcset) img.setAttribute('srcset', info.srcset);
    else img.removeAttribute('srcset');
    if (info.imageWidth) img.setAttribute('width', String(info.imageWidth));
    if (info.imageHeight) img.setAttribute('height', String(info.imageHeight));
  };

  /* THE PRICE ON A CARD FOLLOWS ITS VARIANT PICKER.
   * The figure comes off the chosen <option>'s own attribute rather than
   * from a second table keyed by variant id: Liquid already formatted it
   * there in the shop's currency, so there is one source and it cannot
   * drift from the option the customer is looking at. A card with no picker
   * keeps whatever Liquid wrote and this leaves it alone. Free stays blank
   * -- an entire tier priced at nought would otherwise show a column of
   * zeroes saying only that it is included. */
  Builder.prototype.paintCardPrice = function (card) {
    if (!card) return;
    var out = card.querySelector('[data-ibcb-card-price]');
    var select = card.querySelector('[data-ibcb-variant-select]');
    if (!out || !select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var money = opt.getAttribute('data-ibcb-option-price') || '';
    out.textContent = /^[^0-9]*0([.,]0+)?[^0-9]*$/.test(money) ? '' : money;
  };

  Builder.prototype.cardVariant = function (card) {
    var select = card.querySelector('[data-ibcb-variant-select]');
    if (select && select.value) return select.value;
    var own = card.getAttribute('data-ibcb-variant-id');
    if (own) return own;
    var pid = card.getAttribute('data-ibcb-product-id');
    return this.firstVariant[pid] || '';
  };

  Builder.prototype.paintCardPrices = function () {
    var self = this;
    toArray(this.el.querySelectorAll('[data-ibcb-card]')).forEach(function (card) {
      self.paintCardPrice(card);
    });
  };

  Builder.prototype.paintSummary = function () {
    var self = this;

    this.sumSteps.forEach(function (section, i) {
      var list = section.querySelector('[data-ibcb-sum-list]');
      var counter = section.querySelector('[data-ibcb-sum-count]');
      var n = self.count(i);
      if (counter) counter.textContent = n > 0 ? String(n) : '';
      section.classList.toggle('is-complete', n > 0);
      if (!list) return;

      while (list.firstChild) list.removeChild(list.firstChild);

      (self.picks[i] || []).forEach(function (pick) {
        list.appendChild(self.row(i, pick));
      });

      /* ONE placeholder for an empty step, not one per missing slot: there
       * are no slots left to miss. */
      if (!n) list.appendChild(self.emptyRow());
    });

    /* The extras, in the running summary as well as at the review. They are
     * rows like any other, minus the stepper's "+" — an extra is bought at
     * full price and adding another is a decision, not a nudge — so they get
     * a remove control and a quantity and nothing else. */
    if (this.sumExtras) {
      var extras = this.extraCount();
      this.sumExtras.hidden = !extras;
      if (this.sumExtrasCount) this.sumExtrasCount.textContent = extras ? String(extras) : '';
      if (this.sumExtrasList) {
        while (this.sumExtrasList.firstChild) {
          this.sumExtrasList.removeChild(this.sumExtrasList.firstChild);
        }
        this.extras.forEach(function (extra) {
          self.sumExtrasList.appendChild(self.extraRow(extra, { price: false }));
        });
      }
    }

    /* THE HAMPER, ABOVE THE CHOCOLATES. Not a step and not an extra — it is
     * what they go in — so it gets its own row and its own price, and the
     * price is re-read on every paint because it moves with the size. */
    var hamperRow = this.el.querySelector('[data-ibcb-sum-hamper]');
    if (hamperRow) {
      var variant = this.hamperVariant();
      var show = this.hamperOn && !!variant;
      hamperRow.hidden = !show;
      if (show) {
        var nameNode = hamperRow.querySelector('[data-ibcb-sum-hamper-name]');
        var priceNode = hamperRow.querySelector('[data-ibcb-sum-hamper-price]');
        if (nameNode) {
          nameNode.textContent =
            this.hamperName() +
            (variant.title && variant.title !== DEFAULT_TITLE ? ' ' + DASH + ' ' + variant.title : '');
        }
        if (priceNode) {
          priceNode.textContent = variant.priceFormatted || this.formatMoney(variant.price);
        }
      }
    }

    var chosen = this.totalChosen();
    var word = chosen === 1 ? ' item chosen' : ' items chosen';
    if (this.overall) this.overall.textContent = chosen + word;
    if (this.barCount) this.barCount.textContent = chosen + word;
  };

  Builder.prototype.emptyRow = function () {
    var slot = el('li', 'ibcb-row ibcb-row--empty');
    var mark = el('span', 'ibcb-row__slot');
    mark.setAttribute('aria-hidden', 'true');
    var label = el('span', 'ibcb-row__title');
    label.textContent = this.emptySlot;
    slot.appendChild(mark);
    slot.appendChild(label);
    return slot;
  };

  /* One extra. `opts.price` decides whether its own price is written on the
   * row: false in the running summary, where money does not belong, and true
   * at the review, which is one of the two places it does. */
  Builder.prototype.extraRow = function (extra, options) {
    var opts = options || {};
    var info = this.info(extra.id);
    var item = el('li', 'ibcb-row ibcb-row--extra');
    item.setAttribute('data-ibcb-extra-row', '');
    item.setAttribute('data-ibcb-vid', extra.id);

    if (info.image) {
      var thumb = el('img', 'ibcb-row__thumb');
      thumb.src = info.image;
      thumb.alt = '';
      thumb.setAttribute('loading', 'lazy');
      thumb.setAttribute('decoding', 'async');
      thumb.width = 88;
      thumb.height = 88;
      item.appendChild(thumb);
    } else {
      var blank = el('span', 'ibcb-row__slot');
      blank.setAttribute('aria-hidden', 'true');
      item.appendChild(blank);
    }

    var text = el('span', 'ibcb-row__text');
    var title = el('span', 'ibcb-row__title');
    title.textContent = info.p;
    text.appendChild(title);

    var sub = info.v && info.v !== DEFAULT_TITLE ? info.v : '';
    if (opts.price) {
      var money = this.formatMoney(info.price * extra.qty);
      sub = sub ? sub + ' ' + DASH + ' ' + money : money;
    }
    if (sub) {
      var variant = el('span', 'ibcb-row__variant');
      variant.textContent = sub;
      text.appendChild(variant);
    }
    item.appendChild(text);

    var name = info.p + (info.v && info.v !== DEFAULT_TITLE ? ', ' + info.v : '');
    var controls = el('span', 'ibcb-row__controls');

    var qty = el('span', 'ibcb-row__qty');
    qty.textContent = TIMES + extra.qty;
    controls.appendChild(qty);

    var drop = el('button', 'ibcb-row__btn');
    drop.type = 'button';
    drop.setAttribute('data-ibcb-extra-remove', '');
    drop.setAttribute('aria-label', 'Do not add ' + name + ' separately');
    drop.innerHTML = '&times;';
    controls.appendChild(drop);

    item.appendChild(controls);
    return item;
  };

  /* One compact row: thumbnail, product title, variant title where it means
   * something, the consolidated quantity as ×2, and its controls. */
  Builder.prototype.row = function (index, pick) {
    var info = this.info(pick.id);
    var item = el('li', 'ibcb-row' + (info.gone || !info.available ? ' ibcb-row--gone' : ''));
    item.setAttribute('data-ibcb-row', '');
    item.setAttribute('data-ibcb-index', String(index));
    item.setAttribute('data-ibcb-vid', pick.id);

    if (info.image) {
      var thumb = el('img', 'ibcb-row__thumb');
      thumb.src = info.image;
      thumb.alt = '';
      thumb.setAttribute('loading', 'lazy');
      thumb.setAttribute('decoding', 'async');
      thumb.width = 88;
      thumb.height = 88;
      item.appendChild(thumb);
    } else {
      var blank = el('span', 'ibcb-row__slot');
      blank.setAttribute('aria-hidden', 'true');
      item.appendChild(blank);
    }

    var text = el('span', 'ibcb-row__text');
    var title = el('span', 'ibcb-row__title');
    title.textContent = info.p;
    text.appendChild(title);

    var sub = '';
    if (info.v && info.v !== DEFAULT_TITLE) sub = info.v;
    if (info.gone) {
      sub = sub ? sub + ' ' + DASH + ' no longer available' : 'No longer available';
    } else if (!info.available) {
      sub = sub ? sub + ' ' + DASH + ' sold out' : 'Sold out';
    }
    if (sub) {
      var variant = el('span', 'ibcb-row__variant');
      variant.textContent = sub;
      text.appendChild(variant);
    }
    item.appendChild(text);

    var name = info.p + (info.v && info.v !== DEFAULT_TITLE ? ', ' + info.v : '');
    var controls = el('span', 'ibcb-row__controls');

    var minus = el('button', 'ibcb-row__btn');
    minus.type = 'button';
    minus.setAttribute('data-ibcb-row-dec', '');
    minus.setAttribute('aria-label', 'Remove one ' + name);
    minus.innerHTML = '&minus;';
    controls.appendChild(minus);

    var qty = el('span', 'ibcb-row__qty');
    qty.textContent = TIMES + pick.qty;
    controls.appendChild(qty);

    var plus = el('button', 'ibcb-row__btn');
    plus.type = 'button';
    plus.setAttribute('data-ibcb-row-inc', '');
    plus.setAttribute('aria-label', 'Add another ' + name);
    plus.textContent = '+';
    /* Same deletion as on the card, for the same reason: the cap sentence is
     * gone and the disabled "+" is the signal. The row keeps its title only
     * for the case the customer genuinely cannot work out from looking —
     * something they already chose is no longer buyable. */
    plus.disabled = !this.canAdd(index) || info.gone || !info.available;
    if (plus.disabled && (info.gone || !info.available)) {
      plus.setAttribute('title', 'This one is not available.');
    }
    controls.appendChild(plus);

    var drop = el('button', 'ibcb-row__btn');
    drop.type = 'button';
    drop.setAttribute('data-ibcb-row-remove', '');
    drop.setAttribute('aria-label', 'Take ' + name + ' out of your bundle');
    drop.innerHTML = '&times;';
    controls.appendChild(drop);

    item.appendChild(controls);
    return item;
  };

  /* ---------------------------------------------------- the review stage --
   * The review reads the SAME `picks` arrays the preview reads, so the
   * consolidation cannot drift between the two: one entry per variant per
   * step is a property of the data structure, not of either painter. The
   * same variant twice is one row saying ×2; two variants of one product are
   * two rows, each carrying its own variant title. */

  Builder.prototype.paintReview = function () {
    var self = this;
    if (!this.review) return;

    this.review.hidden = !this.reviewOpen;
    this.el.classList.toggle('is-review', this.reviewOpen);
    if (this.reviewOverall) {
      var chosen = this.totalChosen();
      /* THE ONE PLACE THE ARITHMETIC IS SHOWN IN FULL. The room and the
       * money are two different facts now, so both are stated — and the
       * percentage is dropped when nothing is sized rather than printing a
       * 0% that would read as an empty box. */
      var parts = [chosen + (chosen === 1 ? ' item' : ' items')];
      if (this.capped()) parts.push(this.fullness() + '% of the box filled');
      if (this.total() > 0) parts.push(this.formatMoney(this.total()));
      this.reviewOverall.textContent = parts.join(', ');
    }
    /* THE SPEND. One of the two places money is allowed, and the only place
     * the arithmetic is shown at all. An under-filled bundle is stated
     * plainly and is not a refusal: the brief is explicit that under-filling
     * warns and does not block, so this line is a fact, not an error. */
    if (this.spendNote) {
      var left = this.remaining();
      var floor = this.minSpend();
      var lines = [];
      if (left > 0) {
        lines.push('There is still room in the ' + this.sizeName() + '.');
        if (floor > 0 && this.spent() < floor) {
          lines.push(
            'At least ' +
              this.formatMoney(floor) +
              ' has to be chosen before this bundle can be added.'
          );
        } else {
          lines.push('You can go back and add more, or add it as it is.');
        }
      } else {
        lines.push('Your bundle is full.');
      }
      if (this.extras.length) {
        lines.push(
          'Plus ' +
            this.formatMoney(this.extrasTotal()) +
            ' of items added separately, which are not part of the bundle.'
        );
      }
      this.spendNote.textContent = lines.join(' ');
    }
    if (!this.reviewOpen) return;

    this.reviewSteps.forEach(function (section, i) {
      var list = section.querySelector('[data-ibcb-review-list]');
      var counter = section.querySelector('[data-ibcb-review-count]');
      var n = self.count(i);
      if (counter) counter.textContent = n > 0 ? String(n) : '';
      section.classList.toggle('is-complete', n > 0);
      if (!list) return;

      while (list.firstChild) list.removeChild(list.firstChild);

      (self.picks[i] || []).forEach(function (pick) {
        list.appendChild(self.reviewRow(i, pick, list.getAttribute('data-ibcb-edit-label')));
      });

      /* An empty step is shown as it really is — one placeholder line rather
       * than a picture of a quota, which no longer exists. */
      if (!n) list.appendChild(self.emptyRow());
    });

    /* The extras, with their prices. Their own section, under their own
     * heading, because listing them among the steps would say they were part
     * of the bundle — and the whole point of an extra is that it is not. */
    if (this.extrasBox) {
      var count = this.extraCount();
      this.extrasBox.hidden = !count;
      if (this.extrasCount) this.extrasCount.textContent = count ? String(count) : '';
      if (this.extrasList) {
        while (this.extrasList.firstChild) {
          this.extrasList.removeChild(this.extrasList.firstChild);
        }
        this.extras.forEach(function (extra) {
          self.extrasList.appendChild(self.extraRow(extra, { price: true }));
        });
      }
    }
  };

  /* A review row: what was chosen, how many of it, and one way back to the
   * step that chose it. Read-only apart from that — the point of a review is
   * that it does not invite a stray tap. */
  Builder.prototype.reviewRow = function (index, pick, editLabel) {
    var info = this.info(pick.id);
    /* The step as the CUSTOMER knows it. `step.title` is the cart property
     * name and must never reach a spoken label. */
    var stepName = this.stepLabel(index);
    var item = el(
      'li',
      'ibcb-row ibcb-row--review' + (info.gone || !info.available ? ' ibcb-row--gone' : '')
    );
    item.setAttribute('data-ibcb-row', '');
    item.setAttribute('data-ibcb-index', String(index));
    item.setAttribute('data-ibcb-vid', pick.id);

    if (info.image) {
      var thumb = el('img', 'ibcb-row__thumb');
      thumb.src = info.image;
      thumb.alt = '';
      thumb.setAttribute('loading', 'lazy');
      thumb.setAttribute('decoding', 'async');
      thumb.width = 88;
      thumb.height = 88;
      item.appendChild(thumb);
    } else {
      var blank = el('span', 'ibcb-row__slot');
      blank.setAttribute('aria-hidden', 'true');
      item.appendChild(blank);
    }

    var text = el('span', 'ibcb-row__text');
    var title = el('span', 'ibcb-row__title');
    title.textContent = info.p;
    text.appendChild(title);

    var sub = '';
    if (info.v && info.v !== DEFAULT_TITLE) sub = info.v;
    if (info.gone) {
      sub = sub ? sub + ' ' + DASH + ' no longer available' : 'No longer available';
    } else if (!info.available) {
      sub = sub ? sub + ' ' + DASH + ' sold out' : 'Sold out';
    }
    if (sub) {
      var variant = el('span', 'ibcb-row__variant');
      variant.textContent = sub;
      text.appendChild(variant);
    }
    item.appendChild(text);

    var name = info.p + (info.v && info.v !== DEFAULT_TITLE ? ', ' + info.v : '');
    var controls = el('span', 'ibcb-row__controls');

    var qty = el('span', 'ibcb-row__qty');
    qty.textContent = TIMES + pick.qty;
    controls.appendChild(qty);

    var edit = el('button', 'ibcb-row__edit');
    edit.type = 'button';
    edit.setAttribute('data-ibcb-review-edit', '');
    var editText = el('span', '');
    editText.textContent = editLabel || 'Edit';
    edit.appendChild(editText);
    /* The visible word is "Edit"; the spoken name says what is being edited
     * and which step it lives in, because a column of identical "Edit"
     * buttons is no use to anyone listening. */
    var editName = el('span', 'visually-hidden');
    editName.textContent = ' ' + name + (stepName ? ', in ' + stepName : '');
    edit.appendChild(editName);
    controls.appendChild(edit);

    item.appendChild(controls);
    return item;
  };

  Builder.prototype.openReview = function () {
    if (!this.review || !this.steps.length) return;
    if (!this.reviewOpen) this.reviewFrom = this.step;
    /* Arriving at the review discharges the promise an Edit made. */
    this.reviewReturn = false;
    this.reviewOpen = true;
    /* The size stage and the review are both siblings of the panels and both
     * stand in their place, so exactly one of them can be open. */
    this.sizeOpen = false;
    if (this.sizeStage) this.sizeStage.hidden = true;
    this.el.classList.remove('is-size');
    this.closeTray({ silent: true });
    this.render();

    if (this.review.scrollIntoView) {
      this.review.scrollIntoView({
        behavior: reducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
    }
    this.review.focus();

    var heading = this.review.querySelector('.ibcb__review-title');
    var lead = (heading && heading.textContent) || 'Review your bundle';
    var left = this.remaining();
    var tail;
    if (left === null) {
      /* Nothing sized. A percentage would be invented, so it is not offered. */
      tail = this.totalChosen() + ' chosen.';
    } else if (left > 0) {
      tail = this.totalChosen() + ' chosen. Your bundle is ' + this.fullness() + '% full.';
    } else {
      tail = this.totalChosen() + ' chosen. Your bundle is full.';
    }
    this.say(lead + '. ' + tail);
  };

  Builder.prototype.closeReview = function (options) {
    var opts = options || {};
    if (!this.reviewOpen) return;
    this.reviewOpen = false;
    if (this.review) this.review.hidden = true;
    this.el.classList.remove('is-review');
    if (opts.silent) {
      this.render();
      return;
    }
    /* Back and Escape land the customer on the step they left, announced. */
    this.setStep(Math.min(this.reviewFrom, this.steps.length - 1));
  };

  /* An Edit control in the review. It puts the customer on the step that owns
   * the product and on the product itself, and remembers that they came from
   * the review so the next press of Continue takes them straight back —
   * see `reviewsFrom`. They finished every step to reach the review; walking
   * them through the rest of the flow again to return to the button they
   * were about to press would be a punishment for changing their mind. */
  Builder.prototype.editPick = function (index, variantId) {
    var self = this;
    if (index < 0 || index >= this.steps.length) return;
    /* Only leave the review for a step the customer is actually allowed to
     * stand on. Reaching the review normally guarantees this; reaching it
     * with gaps does not, and closing the review onto nothing would be the
     * worst thing this control could do. */
    if (!this.reachable(index)) {
      this.say('Finish the earlier choices first.');
      return;
    }

    this.reviewOpen = false;
    if (this.review) this.review.hidden = true;
    this.el.classList.remove('is-review');

    this.setStep(index, { silent: true, keepReturn: true });
    this.reviewReturn = true;
    this.render();

    var target = null;
    var panel = this.panels[index];
    if (panel) {
      toArray(panel.querySelectorAll('[data-ibcb-card]')).forEach(function (card) {
        if (target) return;
        if (String(self.cardVariant(card)) !== String(variantId)) return;
        var dec = card.querySelector('[data-ibcb-dec]');
        var box = card.querySelector('[data-ibcb-qty]');
        var add = card.querySelector('[data-ibcb-add]');
        if (dec && box && !box.hidden) target = dec;
        else if (add && !add.hidden && !add.disabled) target = add;
        else target = card.querySelector('[data-ibcb-variant-select]');
      });
    }
    if (!target) target = panel || null;

    var info = this.info(variantId);
    this.say(
      this.stepLabel(index) +
        '. Editing ' +
        info.p +
        '. ' +
        this.count(index) +
        ' chosen.'
    );

    if (target && target.focus) {
      if (target.scrollIntoView) {
        target.scrollIntoView({
          behavior: reducedMotion() ? 'auto' : 'smooth',
          block: 'center'
        });
      }
      target.focus();
    }
  };

  Builder.prototype.paintBuy = function () {
    var self = this;
    var attr = this.editKey ? 'data-ibcb-label-save' : 'data-ibcb-label-add';
    var ok = this.satisfied();

    this.submits.forEach(function (button) {
      button.disabled = !ok || self.busy;
      /* Each copy of the buy block carries its own wording, so the label is
       * read from the button it belongs to rather than paired by position. */
      var node = button.querySelector('[data-ibcb-submit-label]');
      var label = button.getAttribute(attr);
      if (node && label) node.textContent = label;
    });

    /* THE TWO BEHAVIOURS COEXIST, and this is where they are told apart.
     *
     *   under-filled and no minimum set  — a WARNING. The button stays open,
     *                                      the note says how much is unspent
     *                                      and offers the way back.
     *   under-filled and below a minimum — a REFUSAL, with the reason and
     *                                      the number said out loud. The
     *                                      button is closed until the spend
     *                                      reaches the floor.
     *
     * Nothing else closes the button any more except a sold-out item and a
     * bundle that cannot be bought at all. Under-filling never did block and
     * still does not. */
    var message = '';
    var extras = this.extraCount();
    var extraNote = extras
      ? ' ' +
        extras +
        (extras === 1 ? ' item' : ' items') +
        ' will be added to your basket separately, at ' +
        this.formatMoney(this.extrasTotal()) +
        '.'
      : '';

    if (!this.steps.length) {
      message = 'This builder has no steps yet.';
    } else if (!this.bundle.variantId) {
      message = 'This bundle cannot be added just now. Please ring the shop.';
    } else if (!ok && this.belowMinimum()) {
      message =
        'Choose at least ' +
        this.formatMoney(this.minSpend()) +
        ' of this bundle before adding it — ' +
        this.formatMoney(this.minSpend() - this.spent()) +
        ' more to go.';
    } else if (!ok) {
      var gone = [];
      this.steps.forEach(function (step, i) {
        if (self.hasGone(i)) gone.push(self.stepLabel(i).toLowerCase());
      });
      message = gone.length
        ? 'Something in ' + gone.join(', ') + ' is no longer available. Please swap it.'
        : 'This bundle cannot be added just now. Please ring the shop.';
    } else if (this.remaining() !== null && this.remaining() > 0) {
      message =
        'There is still room in the ' +
        this.sizeName() +
        '. You can go back and add more, or add it as it is.' +
        extraNote;
    } else if (this.editKey) {
      message = 'Saving updates the bundle already in your basket.' + extraNote;
    } else {
      message = 'Your bundle is full.' + extraNote;
    }
    this.submitNotes.forEach(function (node) {
      node.textContent = message;
    });
  };

  /* --------------------------------------------------- the rest of the
   * collection. Liquid gave us page 1; the Section Rendering API gives us
   * the rest of the same section, data island and all. ------------------ */

  Builder.prototype.loadPages = function () {
    var self = this;
    if (!window.fetch || !window.DOMParser || !this.layout) return;

    var pages = parseInt(this.layout.getAttribute('data-ibcb-pages'), 10) || 1;
    if (pages < 2) return;

    var last = Math.min(pages, this.maxPages);
    var page = 2;

    function step() {
      if (page > last) return Promise.resolve();
      var url =
        window.location.pathname +
        '?section_id=' +
        encodeURIComponent(self.uid) +
        '&page=' +
        page;
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var island = doc.querySelector('script[type="application/json"][data-ibcb-data]');
          if (!island) return;
          var data = JSON.parse(island.textContent) || {};
          self.merge(data.products || []);
          page += 1;
          return step();
        });
    }

    step()
      .then(function () {
        self.resolveStubs();
        self.render();
      })
      .catch(function () {
        /* Page 1 is still on the screen and still usable — say so rather
         * than pretending the list is complete. */
        self.say('Some of our chocolates could not be loaded. Please refresh if you cannot find one.');
      });
  };

  /* Put every product into every step it belongs in — which is now as many
   * steps as its variants have tiers, and no longer at most one.
   *
   * This runs over PAGE 1 as well as over the pages fetched later, because
   * sections/ibc-bundle.liquid still decides which products to hand the card
   * snippet on the PRODUCT-level metafield. A product carrying no
   * product-level value at all — the Spezzatura case, favourite at 100g and
   * treat at 50g — is offered to no step by Liquid and would otherwise never
   * appear. It is already in the data island, so placing it here costs one
   * pass over the grids on first paint and closes the gap.
   *
   * Idempotent by construction: a grid that already holds a card for this
   * product is left alone, so the cards Liquid did render are never doubled. */
  Builder.prototype.place = function (products) {
    var self = this;
    var grids = toArray(this.el.querySelectorAll('[data-ibcb-grid]'));
    (products || []).forEach(function (product) {
      if (!product) return;
      grids.forEach(function (grid) {
        var tier = grid.getAttribute('data-ibcb-tier') || '';
        var mine = self.variantsFor(product, tier);
        if (!mine.length) return;
        if (
          grid.querySelector(
            '[data-ibcb-card][data-ibcb-product-id="' + String(product.id) + '"]'
          )
        ) {
          return;
        }
        var index = parseInt(grid.getAttribute('data-ibcb-index'), 10) || 0;
        grid.appendChild(self.buildCard(product, index, tier, mine));
      });
    });
    this.paintGridEmpty();
  };

  /* "Nothing here yet" is true of a grid with no cards in it and false of one
   * with cards, and only the DOM knows which — Liquid counted the products it
   * was handed, before the card snippet had filtered their variants, and
   * before `place()` had added any of its own. */
  Builder.prototype.paintGridEmpty = function () {
    var self = this;
    toArray(this.el.querySelectorAll('[data-ibcb-grid]')).forEach(function (grid) {
      var filled = !!grid.querySelector('[data-ibcb-card]');
      var index = parseInt(grid.getAttribute('data-ibcb-index'), 10) || 0;
      var panel = self.panels[index] || (grid.closest ? grid.closest('[data-ibcb-panel]') : null);
      var empty = panel && panel.querySelector('[data-ibcb-grid-empty]');
      if (empty) empty.hidden = filled;
    });
  };

  Builder.prototype.merge = function (products) {
    this.place(this.index(products));
  };

  /* The mirror of snippets/ibc-bundle-card.liquid. Change one, change the
   * other: the two must produce the same element names, classes and ids.
   *
   * `variants` is THIS STEP's subset, not the product's whole list, and
   * `tierKey` is the step's tier rather than anything read off the product —
   * a product in two steps builds two cards, each offering only its own
   * step's variants. The two differ in `scope`, which carries the step index,
   * so every id below stays unique across them.
   *
   * One cosmetic difference from the snippet, which has no bearing on what is
   * chosen: Liquid can prefer the product's own default variant when it
   * qualifies and is in stock, and the island does not carry which variant
   * that is, so here the first qualifying variant in stock is preselected. */
  Builder.prototype.buildCard = function (product, stepIndex, tierKey, variants) {
    var scope = this.uid + '-' + stepIndex;
    var list = variants || [];
    var available = list.some(function (variant) {
      return variant.available;
    });

    var chosen = null;
    list.forEach(function (variant) {
      if (!chosen && variant.available) chosen = variant;
    });
    if (!chosen) chosen = list[0] || null;

    var card = el('li', 'ibcb-card' + (available ? '' : ' is-out'));
    card.setAttribute('data-ibcb-card', '');
    card.setAttribute('data-ibcb-tier', tierKey || '');
    card.setAttribute('data-ibcb-product-id', String(product.id));
    if (chosen) card.setAttribute('data-ibcb-variant-id', String(chosen.id));
    card.setAttribute('data-ibcb-handle', product.handle || '');

    /* THE OFFERED VARIANT'S PICTURE, not the product's — the mirror of the
     * snippet, which now resolves the same way for the same reason. The card
     * opens on `chosen`, so it opens on `chosen`'s photograph; `paintCards`
     * takes it from here the moment the option changes.
     *
     * The island applies the product-featured fallback per variant, so
     * `chosen.image` is populated whenever the product has any picture at
     * all; the `||` chain below is the belt-and-braces for an island from an
     * older render, and the placeholder is reached only when the product has
     * genuinely no image.
     *
     * `sizes` and `loading` MATCH THE SNIPPET EXACTLY. `buildCard()` is the
     * mirror of snippets/ibc-bundle-card.liquid and a card built here must be
     * indistinguishable from one rendered there — a different `sizes` would
     * make the two fetch different candidates for the same tile. */
    var media = el('div', 'ibcb-card__media');
    var shot = (chosen && chosen.image) || product.image || '';
    var shotSet = (chosen && chosen.imageSrcset) || product.imageSrcset || '';
    var shotW = (chosen && chosen.imageWidth) || product.imageWidth || 0;
    var shotH = (chosen && chosen.imageHeight) || product.imageHeight || 0;
    if (shot) {
      var img = el('img', 'ibcb-card__img');
      img.src = shot;
      if (shotSet) {
        img.setAttribute('srcset', shotSet);
        img.setAttribute('sizes', '(min-width: 1024px) 220px, (min-width: 700px) 28vw, 42vw');
      }
      if (shotW) img.setAttribute('width', String(shotW));
      if (shotH) img.setAttribute('height', String(shotH));
      img.alt = product.title || '';
      if (chosen) img.setAttribute('data-ibcb-img-variant', String(chosen.id));
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      img.setAttribute('draggable', 'false');
      media.appendChild(img);
    } else {
      var ph = el('span', 'ibcb-card__ph');
      ph.setAttribute('aria-hidden', 'true');
      media.appendChild(ph);
    }
    var badge = el('span', 'ibcb-card__badge');
    badge.setAttribute('data-ibcb-card-badge', '');
    badge.setAttribute('aria-hidden', 'true');
    badge.hidden = true;
    media.appendChild(badge);
    card.appendChild(media);

    var body = el('div', 'ibcb-card__body');
    var title = el('h4', 'ibcb-card__title');
    title.id = 'ibcb-t-' + scope + '-' + product.id;
    title.textContent = product.title || '';
    body.appendChild(title);

    /* Exactly one qualifying variant is not a choice, so it gets no picker —
     * the treatment a lone "Default Title" variant has always had. The card
     * still names it in `data-ibcb-variant-id`, so 100g and 50g stay told
     * apart with no control to read them off. */
    if (list.length > 1) {
      var label = el('label', 'visually-hidden');
      label.setAttribute('for', 'ibcb-v-' + scope + '-' + product.id);
      label.textContent = 'Choose an option for ' + (product.title || '');
      body.appendChild(label);

      var select = el('select', 'ibcb-card__select');
      select.id = 'ibcb-v-' + scope + '-' + product.id;
      select.setAttribute('data-ibcb-variant-select', '');
      list.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.title + (variant.available ? '' : ' ' + DASH + ' sold out');
        option.setAttribute('data-ibcb-available', variant.available ? 'true' : 'false');
        option.disabled = !variant.available;
        if (chosen && variant.id === chosen.id && variant.available) option.selected = true;
        select.appendChild(option);
      });
      body.appendChild(select);
    }

    var note = el('p', 'ibcb-card__note');
    note.id = 'ibcb-n-' + scope + '-' + product.id;
    note.setAttribute('data-ibcb-card-note', '');
    note.hidden = true;
    body.appendChild(note);

    var foot = el('div', 'ibcb-card__foot');
    var add = el('button', 'ibcb-card__add');
    add.type = 'button';
    add.setAttribute('data-ibcb-add', '');
    add.setAttribute('aria-describedby', note.id);
    var addLabel = el('span', 'ibcb-card__add-label');
    addLabel.textContent = 'Add';
    add.appendChild(addLabel);
    var addName = el('span', 'visually-hidden');
    addName.textContent = ' ' + (product.title || '');
    add.appendChild(addName);
    foot.appendChild(add);

    var qty = el('div', 'ibcb-card__qty');
    qty.setAttribute('data-ibcb-qty', '');
    qty.hidden = true;

    var minus = el('button', 'ibcb-card__step');
    minus.type = 'button';
    minus.setAttribute('data-ibcb-dec', '');
    minus.setAttribute('aria-label', 'Remove one ' + (product.title || ''));
    minus.innerHTML = '&minus;';
    qty.appendChild(minus);

    var count = el('span', 'ibcb-card__count');
    count.setAttribute('data-ibcb-count', '');
    count.setAttribute('aria-hidden', 'true');
    count.textContent = '0';
    qty.appendChild(count);

    var plus = el('button', 'ibcb-card__step');
    plus.type = 'button';
    plus.setAttribute('data-ibcb-inc', '');
    plus.setAttribute('aria-label', 'Add another ' + (product.title || ''));
    plus.setAttribute('aria-describedby', note.id);
    plus.textContent = '+';
    qty.appendChild(plus);

    foot.appendChild(qty);
    body.appendChild(foot);
    card.appendChild(body);
    return card;
  };

  /* An item restored from the cart whose product arrived on a later page. */
  Builder.prototype.resolveStubs = function () {
    var self = this;
    Object.keys(this.stubs).forEach(function (key) {
      if (self.byVariant[key]) delete self.stubs[key];
    });
  };

  /* ---------------------------------------------------------- edit mode -- */

  Builder.prototype.loadEdit = function () {
    var self = this;
    if (!window.fetch) return;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        var line = null;
        /* BY GROUP ID FIRST, BY LINE KEY SECOND.
         *
         * /cart/change.js re-keys a line whenever its properties change and
         * can reorder the basket, so an Edit link built from a line key is
         * stale the moment anything else in the basket moves. The group id is
         * written by this file and never changes for the life of a bundle.
         *
         * The key branch stays for the links already out there — a basket
         * that was open when this shipped, a tab left sitting since this
         * morning — and only ever matches the HEADER, because that is the one
         * line carrying the bundle record. */
        (cart.items || []).forEach(function (item) {
          if (line) return;
          var props = item.properties || {};
          if (!props[PROPS.items]) return;
          if (props[PROPS.id] === self.editKey || item.key === self.editKey) line = item;
        });
        if (!line) throw new Error('line not found');

        var props = line.properties || {};
        var raw = props[PROPS.items];
        if (!raw) throw new Error('no bundle record');

        self.savedId = props[PROPS.id] || '';

        /* THE HAMPER IS NOT IN THE BUNDLE RECORD, and should not be: the
         * record is what the customer chose to put IN the box, and the
         * hamper is the box. It is found the only honest way — by looking for
         * one of its variants among the lines joined to this bundle — so a
         * hamper the customer added is still there when they come back to
         * change a chocolate, and is not quietly dropped on save. */
        if (self.hasHamper) {
          /* CLEARED FIRST. The default is on, and a bundle saved without a
           * basket must come back without one — otherwise editing a
           * chocolate would quietly add the basket the customer declined. */
          self.hamperOn = false;
          var group = props[PROPS.group] || props[PROPS.id] || '';
          var ours = {};
          self.hamperVariants.forEach(function (variant) {
            ours[String(variant.id)] = true;
          });
          (cart.items || []).forEach(function (candidate) {
            var cp = candidate.properties || {};
            if (group && cp[PROPS.group] !== group) return;
            if (ours[String(candidate.variant_id)]) self.hamperOn = true;
          });
        }

        self.restore(JSON.parse(raw));
      })
      .catch(function () {
        self.editKey = '';
        self.showError(
          'We could not find that bundle in your basket, so this is a fresh one. Nothing has been changed in your basket.'
        );
        self.render();
      });
  };

  /* THE CART IS THE SOURCE OF TRUTH. Everything needed to rebuild the
   * bundle is in `_IBC Bundle Items` — variant id, quantity, tier key and
   * both titles — so a restore works in a browser that has never seen this
   * page before. */
  Builder.prototype.restore = function (items) {
    var self = this;
    var i;
    for (i = 0; i < this.picks.length; i += 1) this.picks[i] = [];
    this.stubs = {};

    var missing = 0;

    (items || []).forEach(function (entry) {
      if (!entry || !entry.id) return;
      var key = String(entry.id);
      var qty = parseInt(entry.q, 10) || 1;

      var stepIndex = -1;
      self.steps.forEach(function (step, index) {
        if (stepIndex === -1 && step.key === entry.t) stepIndex = index;
      });
      /* The stored tier is the first authority. Failing that, the catalogue's
       * — which is now the VARIANT's own tier, so a bundle saved before a
       * product was split across two steps lands its 50g bag in the treat
       * step rather than wherever the product as a whole used to sit. */
      if (stepIndex === -1) {
        var known = self.byVariant[key];
        self.steps.forEach(function (step, index) {
          if (stepIndex === -1 && known && step.key === known.tier) stepIndex = index;
        });
      }
      if (stepIndex === -1) {
        missing += 1;
        return;
      }

      if (!self.byVariant[key]) {
        self.stubs[key] = { p: entry.p || 'This item', v: entry.v || '' };
        missing += 1;
      }

      var list = self.picks[stepIndex];
      var existing = null;
      list.forEach(function (pick) {
        if (pick.id === key) existing = pick;
      });
      if (existing) {
        existing.qty += qty;
      } else {
        list.push({ id: key, qty: qty });
      }
    });

    this.render();
    if (missing > 0) {
      this.showError(
        'Your bundle is here, but ' +
          missing +
          (missing === 1 ? ' item is' : ' items are') +
          ' no longer available. Swap ' +
          (missing === 1 ? 'it' : 'them') +
          ' and your changes will save.'
      );
    } else {
      this.say('Your bundle has been loaded and is ready to edit.');
    }
  };

  /* ------------------------------------------------------------ the tray -- */

  Builder.prototype.openTray = function (opener) {
    if (!isSheet()) return;
    this.trayOpener = opener || null;
    this.el.classList.add('is-tray-open');
    if (this.scrim) this.scrim.hidden = false;
    var button = this.el.querySelector('[data-ibcb-tray-open]');
    if (button) button.setAttribute('aria-expanded', 'true');
    var close = this.el.querySelector('[data-ibcb-tray-close]');
    if (close) close.focus();
  };

  Builder.prototype.closeTray = function (options) {
    var opts = options || {};
    if (!this.el.classList.contains('is-tray-open')) return;
    this.el.classList.remove('is-tray-open');
    if (this.scrim) this.scrim.hidden = true;
    var button = this.el.querySelector('[data-ibcb-tray-open]');
    if (button) button.setAttribute('aria-expanded', 'false');
    if (!opts.silent && this.trayOpener && this.trayOpener.focus) this.trayOpener.focus();
    else if (!opts.silent && button) button.focus();
    this.trayOpener = null;
  };

  Builder.prototype.trapTab = function (event) {
    if (!this.el.classList.contains('is-tray-open') || !this.aside) return;
    var nodes = toArray(this.aside.querySelectorAll(FOCUSABLE)).filter(function (node) {
      return node.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  /* ------------------------------------------------------------ the add -- */

  /* THE LAST GATE BEFORE THE POST. Under-filling is deliberately absent: it
   * is a warning painted by `paintBuy`, never a refusal. What is left is a
   * bundle that cannot be bought, an item that has sold out, a minimum spend
   * the merchant asked for, and — as a belt-and-braces check that should
   * never fire, because `add()` guards it — a selection that costs more than
   * the size it is going into. */
  Builder.prototype.validate = function () {
    if (!this.steps.length) return 'This builder has no steps yet.';
    if (!this.bundle.variantId) return 'This bundle cannot be added just now. Please ring the shop.';
    var i;
    for (i = 0; i < this.steps.length; i += 1) {
      if (this.hasGone(i)) {
        return (
          'Something in ' + this.stepLabel(i).toLowerCase() + ' is no longer available. Please swap it.'
        );
      }
    }
    if (this.belowMinimum()) {
      return (
        'Please choose at least ' +
        this.formatMoney(this.minSpend()) +
        ' of this bundle before adding it.'
      );
    }
    if (this.capped() && this.remaining() < 0) {
      return (
        'Your choices come to more than the ' +
        this.sizeName() +
        ' holds. Please take something out or choose a larger size.'
      );
    }
    return '';
  };

  /* Availability is re-read from the shop at the moment of the add, so a
   * piece that sold out while the customer was choosing is caught here and
   * not at the checkout. */
  Builder.prototype.revalidate = function () {
    var self = this;
    if (!window.fetch) return Promise.resolve([]);

    var handles = [];
    var wanted = {};
    function want(id) {
      var found = self.byVariant[id];
      if (!found || !found.handle) return;
      wanted[id] = true;
      if (handles.indexOf(found.handle) === -1) handles.push(found.handle);
    }

    this.picks.forEach(function (list) {
      list.forEach(function (pick) {
        want(pick.id);
      });
    });
    /* The extras go through the same check. They are separate cart lines but
     * they are posted in the same request, and a sold-out extra would fail
     * the whole /cart/add.js call and take the bundle down with it. */
    this.extras.forEach(function (extra) {
      want(extra.id);
    });
    if (!handles.length) return Promise.resolve([]);

    return Promise.all(
      handles.map(function (handle) {
        return fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (results) {
      var gone = [];
      results.forEach(function (product) {
        if (!product) return;
        (product.variants || []).forEach(function (variant) {
          var key = String(variant.id);
          var known = self.byVariant[key];
          if (!known) return;
          known.variant.available = !!variant.available;
          if (wanted[key] && !variant.available) gone.push(key);
        });
      });
      return gone;
    });
  };

  Builder.prototype.properties = function () {
    var self = this;
    var props = {};
    var items = [];

    /* A FRESH ID ON EVERY ADD, INCLUDING AN EDIT.
     *
     * An edit used to keep the old id, because an edit used to be one
     * /cart/change.js against one line. A bundle is many lines now, so saving
     * is add-the-new-group-then-zero-the-old — and if the new lines carried
     * the old id they would merge straight into the lines they are meant to
     * replace, doubling every quantity on the way past. The old id is kept in
     * `savedId`, which is how `commit()` knows what to clear away. */
    props[PROPS.id] = bundleId();
    props[PROPS.group] = props[PROPS.id];

    this.steps.forEach(function (step, index) {
      var parts = [];
      (self.picks[index] || []).forEach(function (pick) {
        var info = self.info(pick.id);
        var label = pick.qty + ' ' + TIMES + ' ' + info.p;
        if (info.v && info.v !== DEFAULT_TITLE) label += ' ' + DASH + ' ' + info.v;
        parts.push(label);
        items.push({
          id: parseInt(pick.id, 10),
          q: pick.qty,
          t: step.key,
          p: info.p,
          v: info.v || ''
        });
      });
      /* `step.title`, NOT `step.label`. The title is the line-item property
       * name — the one orders, the basket and the Cart Transform Function
       * already read — and the wording change to Cake / Favourites / Treats
       * was applied to `label`, which is a display string and never appears
       * here. This one line is the whole reason the two were split.
       *
       * A step with nothing in it writes an empty value rather than being
       * omitted, exactly as it always has. That now happens routinely — the
       * cake is optional — and the shape of the payload is unchanged for it:
       * every configured step still contributes exactly one property. */
      props[step.title] = parts.join(', ');
    });

    /* EXTRAS ARE NOT IN HERE, and this is the line that guarantees it. They
     * are not in `picks`, so they cannot reach `items`, and nothing below
     * adds them. They go to the cart as their own ordinary lines — see
     * `commit()`. */

    props[PROPS.items] = JSON.stringify(items);
    return props;
  };

  /* ONE CART LINE PER CHOCOLATE, at its own variant and its own real price.
   *
   * Shopify prices a line by its variant, so no single line can cost the sum
   * of the things named in its properties. That is the whole reason the
   * bundle stopped being one line: the price is the contents now, and the
   * contents therefore have to BE lines. The header is the £0 IBC Bundle
   * variant, and it leads the group.
   *
   * What a member carries is deliberately almost nothing: the join and the
   * per-bundle quantity. No tier, no step wording, no bundle record — those
   * live once, on the header, where an order or a packing slip reads them
   * without having to de-duplicate N copies.
   *
   * EXTRAS ARE NOT MEMBERS. They are not in `picks`, so they cannot reach
   * here, and they go to the basket as bare lines with no properties at all —
   * which is what makes an extra indistinguishable from the same chocolate
   * bought on its own page. */
  Builder.prototype.memberLines = function (groupId) {
    var lines = [];
    this.picks.forEach(function (list) {
      (list || []).forEach(function (pick) {
        var props = {};
        props[PROPS.group] = groupId;
        props[PROPS.unit] = String(pick.qty);
        lines.push({
          id: parseInt(pick.id, 10),
          quantity: pick.qty,
          properties: props
        });
      });
    });
    return lines;
  };

  /* The keys of the lines the edit is replacing, read from the basket AT THE
   * MOMENT OF SAVING rather than trusted from page load: /cart/change.js
   * re-keys a line whenever its properties change and can reorder the basket,
   * so anything read earlier is already stale.
   *
   * The group just added is excluded by id, so a save can never zero the very
   * lines it has this second created. A bundle from before the split has a
   * `Bundle ID` and no `_Bundle Group` at all; it is matched on that, and on
   * the line key the old Edit links still carry, so a basket that was open
   * when this shipped still saves correctly. */
  Builder.prototype.staleKeys = function (cart, freshId) {
    var self = this;
    var keys = [];
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props[PROPS.group] === freshId) return;
      var mine =
        (self.savedId && props[PROPS.group] === self.savedId) ||
        (self.savedId && !props[PROPS.group] && props[PROPS.id] === self.savedId) ||
        (self.editKey && item.key === self.editKey);
      if (mine) keys.push(item.key);
    });
    return keys;
  };

  Builder.prototype.setBusy = function (state) {
    this.busy = state;
    this.submits.forEach(function (button) {
      if (state) {
        button.setAttribute('data-loading', '');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      } else {
        button.removeAttribute('data-loading');
        button.removeAttribute('aria-busy');
      }
    });
  };

  Builder.prototype.commit = function () {
    var self = this;
    if (this.busy) return; /* double-submit guard */

    var problem = this.validate();
    if (problem) {
      this.showError(problem);
      return;
    }

    this.clearError();
    this.setBusy(true);
    this.say(this.editKey ? 'Saving your bundle…' : 'Adding your bundle to your basket…');

    this.revalidate()
      .then(function (gone) {
        if (gone.length) {
          self.render();
          var names = gone.map(function (key) {
            var info = self.info(key);
            return info.v && info.v !== DEFAULT_TITLE ? info.p + ' ' + DASH + ' ' + info.v : info.p;
          });
          throw new Error(
            'Sold out while you were choosing: ' +
              names.join(', ') +
              '. Please swap ' +
              (names.length === 1 ? 'it' : 'them') +
              ' and try again.'
          );
        }

        var props = self.properties();
        var groupId = props[PROPS.id];

        /* THE EXTRAS ARE ORDINARY LINES. `{ id, quantity }` and nothing else
         * — no group, no properties at all. An extra in the basket is
         * indistinguishable from the same chocolate bought on its own page,
         * which is exactly what it is. */
        var extraLines = self.extras.map(function (extra) {
          return { id: parseInt(extra.id, 10), quantity: extra.qty };
        });

        /* THE HAMPER IS AN ORDINARY MEMBER LINE. Its own product, its own
         * real price, joined to the bundle like every chocolate in it — so
         * it is removed with the bundle, scales with the bundle's quantity
         * and appears on the order as the thing the shop actually has to
         * order in. It carries no capacity: it is the container, not
         * something in it, which is true for free because it never goes
         * near `picks`. */
        var hamperLines = [];
        if (self.hamperOn) {
          var hamperVariant = self.hamperVariant();
          if (hamperVariant && hamperVariant.available !== false) {
            var hamperProps = {};
            hamperProps[PROPS.group] = groupId;
            hamperProps[PROPS.unit] = '1';
            hamperLines.push({
              id: parseInt(hamperVariant.id, 10),
              quantity: 1,
              properties: hamperProps
            });
          }
        }

        /* ONE request: the £0 header first, then the hamper, then a line per
         * chocolate, then any extras. Shopify keeps the order it is given, so
         * the bundle reads as a block with its header at the top and its
         * container directly under it. */
        var add = jsonPost(root() + 'cart/add.js', {
          items: [{ id: self.bundle.variantId, quantity: 1, properties: props }]
            .concat(hamperLines)
            .concat(self.memberLines(groupId))
            .concat(extraLines)
        });

        if (!self.editKey && !self.savedId) return add;

        /* SAVING AN EDIT: ADD FIRST, CLEAR SECOND.
         *
         * In that order, deliberately. If the add fails, nothing has been
         * taken away and the old bundle is still in the basket. If the clear
         * fails, the customer has two bundles — visible, named and removable
         * — rather than none. The reverse order can lose a bundle outright.
         * assets/ibc-multipack.js settled this; the reasoning is the same. */
        return add.then(function (result) {
          self.extras = [];
          return fetchCart()
            .then(function (cart) {
              var keys = self.staleKeys(cart, groupId);
              if (!keys.length) return result;
              var updates = {};
              keys.forEach(function (key) {
                updates[key] = 0;
              });
              return jsonPost(root() + 'cart/update.js', { updates: updates }).then(function () {
                return result;
              });
            })
            .catch(function () {
              /* The new bundle IS in the basket. Failing to tidy the old one
               * away is untidy, not lost work, and throwing here would tell
               * the customer their save had failed when it had not. */
              return result;
            });
        });
      })
      .then(function (result) {
        self.setBusy(false);
        self.render();
        self.closeTray({ silent: true });
        self.say(self.editKey ? 'Your bundle has been updated.' : 'Your bundle is in your basket.');
        self.done(result);
      })
      .catch(function (error) {
        self.setBusy(false);
        self.render();
        self.showError(
          (error && error.message) ||
            'We could not update your basket just now. Your choices are still here — please try again.'
        );
      });
  };

  /* The theme's cart controller owns the drawer and the cart page; it listens
   * for `ibc:cart-changed` from anything that is not itself. Without it —
   * an older layout, a stripped page — go to the cart. */
  Builder.prototype.done = function (result) {
    var cart = result && typeof result.item_count === 'number' ? result : null;
    if (window.IbcCart) {
      document.dispatchEvent(
        new CustomEvent('ibc:cart-changed', {
          bubbles: true,
          detail: {
            cart: cart,
            item_count: cart ? cart.item_count : undefined,
            items: cart ? cart.items : undefined,
            source: 'bundle'
          }
        })
      );
      return;
    }
    window.location.href = root() + 'cart';
  };

  Builder.prototype.destroy = function () {
    this.closeTray({ silent: true });
    this.closeDialog({ silent: true });
    this.closeReview({ silent: true });
    this.sizeOpen = false;
    if (this.el) this.el.classList.remove('is-size', 'is-dialog');
    if (this.el) {
      this.el._ibcBundle = null;
      this.el.classList.remove('is-ready');
      this.el.classList.remove('is-review');
    }
    var index = instances.indexOf(this);
    if (index !== -1) instances.splice(index, 1);
  };

  /* ==================================================================== */

  var instances = [];

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-ibcb-root]')).forEach(function (node) {
      if (node._ibcBundle) return;
      if (node.getAttribute('data-ibcb-inert') === 'true') return;
      var builder = new Builder(node);
      instances.push(builder);
    });
  }

  function destroyIn(scope) {
    instances.slice().forEach(function (builder) {
      if (
        !builder.el ||
        !builder.el.isConnected ||
        !scope ||
        scope === document ||
        scope.contains(builder.el)
      ) {
        builder.destroy();
      }
    });
  }

  function owner(node) {
    var host = node && node.closest ? node.closest('[data-ibcb-root]') : null;
    return host ? host._ibcBundle : null;
  }

  function stepIndexOf(node) {
    var scope = node.closest('[data-ibcb-grid], [data-ibcb-panel], [data-ibcb-sum-step], [data-ibcb-row]');
    if (!scope) return 0;
    return parseInt(scope.getAttribute('data-ibcb-index'), 10) || 0;
  }

  /* ------------------------------------------------------------------ */
  /* Document-level listeners: bound exactly once, at module scope, behind
   * the `window.IbcBundle` guard at the top of this file. They dispatch to
   * whatever instances are live, so a theme-editor reload cannot stack a
   * second copy of any of them. */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var builder = owner(target);
    if (!builder) return;

    var hit;

    /* ------------------------------------------------------- the dialog --
     * FIRST, because the dialog sits inside the root and a press on one of
     * its buttons must never also be read as a press on whatever it is
     * covering. Actions are dispatched by index out of `_actions`, which is
     * rebuilt each time the panel opens. */
    hit = target.closest('[data-ibcb-dialog-action]');
    if (hit) {
      event.preventDefault();
      var at = parseInt(hit.getAttribute('data-ibcb-dialog-action'), 10);
      var action = builder._actions[at];
      /* Closed NON-silently, so focus goes back to the control the customer
       * pressed BEFORE the action runs. If the action opens a second dialog
       * — changing up to a size that still will not hold the item — that
       * dialog stores the same trigger and the journey stays anchored to the
       * "+" the whole way through. Closing silently would leave focus on a
       * button that no longer exists, which is the top of the page. */
      builder.closeDialog();
      if (action && typeof action.run === 'function') action.run();
      return;
    }

    hit = target.closest('[data-ibcb-dialog-dismiss]');
    if (hit) {
      event.preventDefault();
      /* Cancel, the scrim and the close button all mean the same thing and
       * all do the same thing: nothing is added. */
      builder.closeDialog();
      return;
    }

    /* --------------------------------------------------------- the size --
     * Real links. The click is intercepted ONLY when the page's own product
     * controller is there to take the choice; otherwise the browser
     * navigates to `?variant=<id>` and Liquid re-renders the builder against
     * it, which is the whole point of rendering them as anchors. This is
     * assets/ibc-gift-box.js's rule, not a new one. */
    hit = target.closest('[data-ibcb-size-tile]');
    if (hit) {
      if (window.IbcProduct && typeof window.IbcProduct.select === 'function') {
        event.preventDefault();
        builder.chooseSize(hit.getAttribute('data-ibcb-variant-id'));
      }
      return;
    }

    hit = target.closest('[data-ibcb-size-tab]');
    if (hit) {
      event.preventDefault();
      builder.openSize();
      return;
    }

    hit = target.closest('[data-ibcb-size-go]');
    if (hit) {
      event.preventDefault();
      builder.closeSize();
      return;
    }

    /* ------------------------------------------------- the presentation --
     * Buttons, not links, and no no-JavaScript path: a hamper is a second
     * product on a second cart line and nothing but a script can add one.
     * The stage stays hidden without this file, so nothing on the page
     * promises a choice it cannot deliver. */
    hit = target.closest('[data-ibcb-pres-tile]');
    if (hit) {
      event.preventDefault();
      builder.chooseHamper(hit.getAttribute('data-ibcb-hamper') === 'true');
      return;
    }

    hit = target.closest('[data-ibcb-pres-tab]');
    if (hit) {
      event.preventDefault();
      builder.openPres();
      return;
    }

    hit = target.closest('[data-ibcb-pres-go]');
    if (hit) {
      event.preventDefault();
      builder.closePres();
      return;
    }

    /* The way back, from the one piece of furniture that is on screen for
     * the whole flow. */
    hit = target.closest('[data-ibcb-step-back]');
    if (hit) {
      event.preventDefault();
      builder.goBack();
      return;
    }

    hit = target.closest('[data-ibcb-skip]');
    if (hit) {
      event.preventDefault();
      builder.skipStep(stepIndexOf(hit));
      return;
    }

    hit = target.closest('[data-ibcb-extra-remove]');
    if (hit) {
      event.preventDefault();
      var extraRow = hit.closest('[data-ibcb-extra-row]');
      if (!extraRow) return;
      builder.removeExtra(extraRow.getAttribute('data-ibcb-vid'), true);
      return;
    }

    hit = target.closest('[data-ibcb-tab]');
    if (hit) {
      event.preventDefault();
      builder.setStep(parseInt(hit.getAttribute('data-ibcb-index'), 10) || 0);
      return;
    }

    hit = target.closest('[data-ibcb-add], [data-ibcb-inc]');
    if (hit) {
      event.preventDefault();
      var card = hit.closest('[data-ibcb-card]');
      if (!card) return;
      /* The control is handed on as `trigger` so that, if this opens the
       * over-budget dialog, focus comes back to the button the customer
       * actually pressed rather than to the top of the page. */
      builder.add(stepIndexOf(card), builder.cardVariant(card), 1, { trigger: hit });
      return;
    }

    hit = target.closest('[data-ibcb-dec]');
    if (hit) {
      event.preventDefault();
      var decCard = hit.closest('[data-ibcb-card]');
      if (!decCard) return;
      builder.remove(stepIndexOf(decCard), builder.cardVariant(decCard), false);
      return;
    }

    hit = target.closest('[data-ibcb-row-inc]');
    if (hit) {
      event.preventDefault();
      var incRow = hit.closest('[data-ibcb-row]');
      if (!incRow) return;
      builder.add(stepIndexOf(incRow), incRow.getAttribute('data-ibcb-vid'), 1, { trigger: hit });
      return;
    }

    hit = target.closest('[data-ibcb-row-dec]');
    if (hit) {
      event.preventDefault();
      var decRow = hit.closest('[data-ibcb-row]');
      if (!decRow) return;
      builder.remove(stepIndexOf(decRow), decRow.getAttribute('data-ibcb-vid'), false);
      return;
    }

    hit = target.closest('[data-ibcb-row-remove]');
    if (hit) {
      event.preventDefault();
      var dropRow = hit.closest('[data-ibcb-row]');
      if (!dropRow) return;
      builder.remove(stepIndexOf(dropRow), dropRow.getAttribute('data-ibcb-vid'), true);
      return;
    }

    /* ONE branch for all three views of Continue — the panel's, the panel
     * heading's and the mobile bar's. They differ in where they sit and in
     * nothing else. */
    hit = target.closest('[data-ibcb-next]');
    if (hit) {
      event.preventDefault();
      builder.advance(hit);
      return;
    }

    hit = target.closest('[data-ibcb-review-edit]');
    if (hit) {
      event.preventDefault();
      var editRow = hit.closest('[data-ibcb-row]');
      if (!editRow) return;
      builder.editPick(
        parseInt(editRow.getAttribute('data-ibcb-index'), 10) || 0,
        editRow.getAttribute('data-ibcb-vid')
      );
      return;
    }

    hit = target.closest('[data-ibcb-review-back]');
    if (hit) {
      event.preventDefault();
      builder.closeReview();
      return;
    }

    hit = target.closest('[data-ibcb-back]');
    if (hit) {
      event.preventDefault();
      /* The panel's own Back and the persistent bar's Back are the SAME
       * journey and go through the same `goBack()` — which is what puts the
       * customer on the size stage from the first step rather than nowhere. */
      builder.goBack();
      return;
    }

    hit = target.closest('[data-ibcb-tray-open]');
    if (hit) {
      event.preventDefault();
      builder.openTray(hit);
      return;
    }

    hit = target.closest('[data-ibcb-tray-close], [data-ibcb-scrim]');
    if (hit) {
      event.preventDefault();
      builder.closeTray();
      return;
    }

    hit = target.closest('[data-ibcb-submit]');
    if (hit) {
      event.preventDefault();
      builder.commit();
    }
  });

  /* A variant change re-points the card at a different variant, so its
   * quantity, its badge and its disabled state all have to be re-read. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('[data-ibcb-variant-select]')) return;
    var builder = owner(target);
    if (builder) builder.render();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Tab') return;

    /* THE DIALOG FIRST. It is the only real modal in this feature — the
     * review and the size stage stand in the panels' place and are not
     * overlays — so while it is up it owns Escape and it owns Tab. */
    var dialoguing = null;
    instances.forEach(function (builder) {
      if (builder.dialog && !builder.dialog.hidden) dialoguing = builder;
    });
    if (dialoguing) {
      if (event.key === 'Escape') {
        event.preventDefault();
        dialoguing.closeDialog();
      } else {
        dialoguing.trapDialog(event);
      }
      return;
    }

    var open = null;
    instances.forEach(function (builder) {
      if (builder.el && builder.el.classList.contains('is-tray-open')) open = builder;
    });
    if (open) {
      if (event.key === 'Escape') {
        event.preventDefault();
        open.closeTray();
      } else {
        open.trapTab(event);
      }
      return;
    }

    /* The review is not a dialog — it stands in the panels' place — so Tab
     * runs through the page as usual and only Escape is special: it leaves
     * the review for the step the customer came from. */
    if (event.key !== 'Escape') return;
    var standing = null;
    var kind = '';
    instances.forEach(function (builder) {
      if (!builder.el || !builder.el.contains(document.activeElement)) return;
      if (builder.reviewOpen) {
        standing = builder;
        kind = 'review';
      } else if (builder.sizeOpen) {
        standing = builder;
        kind = 'size';
      }
    });
    if (!standing) return;
    event.preventDefault();
    /* Both stages leave the same way they were entered: back to the step the
     * customer was standing on. Neither is a dialog, so Tab is untouched. */
    if (kind === 'review') standing.closeReview();
    else standing.closeSize();
  });

  /* The sheet is a phone and tablet idea. Dragged wide, it must not leave a
   * scrim over a desktop layout. */
  window.addEventListener('resize', function () {
    if (isSheet()) return;
    instances.slice().forEach(function (builder) {
      builder.closeTray({ silent: true });
    });
  });

  /* THE PAGE'S OWN VARIANT PICKER, ANSWERING BACK. <ibc-product> dispatches
   * this whenever the selected variant changes — whether it was one of our
   * size tiles that asked, or the product page's own chips, or a `?variant=`
   * arriving through history. Reconciling here means the builder's budget
   * follows the page rather than the other way round, and it is the same
   * seam assets/ibc-gift-box.js listens on. `setSize` rather than
   * `chooseSize`, so answering the page does not bounce straight back out to
   * it. */
  document.addEventListener('ibc:product-selection', function (event) {
    var detail = event.detail || {};
    if (!detail.variantId) return;
    instances.slice().forEach(function (builder) {
      if (detail.element && !detail.element.contains(builder.el)) return;
      builder.setSize(detail.variantId, { silent: true });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target || document);
  });

  initAll(document);

  window.IbcBundle = {
    properties: PROPS,
    init: initAll,
    instances: instances,
    forElement: function (node) {
      return node ? node._ibcBundle || null : null;
    }
  };
})();
